/* Two products since 2026-10-21: B complex buy buttons replace only B complex lines and keep any magnesium in the
   basket (was /cart/clear.js, which emptied it). */
window.pvClearBC = function(){ return fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){ var u = {};
  (c.items || []).forEach(function(i){ if (i.handle !== 'magnesium-glycinate') u[i.key] = 0; });
  return Object.keys(u).length ? fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: u }) }) : null; }); };
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {

    // -- Scroll reveal ------------------------------------------
    var io = ('IntersectionObserver' in window)
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('pv-in'); io.unobserve(e.target); } });
        }, { threshold: 0.08 })
      : null;
    document.querySelectorAll('.pv-reveal').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('pv-in');
    });

    // -- Hero image gallery (auto-rotate every 5s + swipe + dots) --
    (function () {
      var gallery = document.querySelector('.pv-hero-gallery');
      if (!gallery) return;
      if (gallery.dataset.pvGalleryInit) return; gallery.dataset.pvGalleryInit = '1';
      var track = gallery.querySelector('.pv-hg-track');
      var slides = track ? track.querySelectorAll('.pv-hg-slide') : [];
      var dotsWrap = gallery.querySelector('.pv-hg-dots');
      if (!track || slides.length < 2) return;
      var count = slides.length, idx = 0, timer = null, dots = [];
      for (var i = 0; i < count; i++) {
        (function (i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'pv-hg-dot' + (i === 0 ? ' pv-active' : '');
          b.setAttribute('aria-label', 'Go to image ' + (i + 1));
          b.addEventListener('click', function () { goTo(i, true); });
          dotsWrap.appendChild(b); dots.push(b);
        })(i);
      }
      // Thumbnail rail: same navigation as the dots (goTo), and hide the dots since the thumbs replace them.
      var thumbs = gallery.querySelectorAll('.pv-hg-thumb');
      if (thumbs.length && dotsWrap) dotsWrap.style.display = 'none';
      for (var ti = 0; ti < thumbs.length; ti++) {
        (function (ti) { thumbs[ti].addEventListener('click', function () { goTo(ti, true); }); })(ti);
      }
      function slideW() { return slides[0].getBoundingClientRect().width; }
      /* Video slides in the gallery (owner 2026-09-06). The <video> is built ONLY when its slide is
         opened, never on page load: this is the hero, above the fold, where the LCP lives, so a
         customer who never swipes past the photos downloads no video at all. Muted + inline so it can
         autoplay; tapping toggles sound. Leaving the slide pauses it and drops it back to muted. */
      function hgVideo(slide) {
        if (!slide || !slide.hasAttribute('data-pv-hg-video')) return null;
        var v = slide.querySelector('video');
        if (v) return v;
        v = document.createElement('video');
        v.src = slide.getAttribute('data-pv-hg-video');
        v.muted = true; v.defaultMuted = true; v.loop = true; v.controls = false;
        v.playsInline = true; v.setAttribute('playsinline', ''); v.setAttribute('muted', '');
        v.setAttribute('webkit-playsinline', '');
        /* T-0434W: 'metadata' until the visitor taps. Arriving on a video slide only builds the element; with 'auto'
           it also began downloading the whole 720p file (up to 35 MB) on Wi-Fi and desktop. iOS already treats
           'auto' as 'metadata', so the tap behaviour there is unchanged. hgPlay() switches to 'auto'. */
        v.preload = 'metadata';
        try { v.disablePictureInPicture = true; } catch (e) {}
        v.setAttribute('disablepictureinpicture', '');
        v.setAttribute('controlslist', 'nodownload noplaybackrate noremoteplayback');
        v.setAttribute('x-webkit-airplay', 'deny');
        var p = slide.querySelector('.pv-hg-vposter');
        if (p) v.setAttribute('poster', p.getAttribute('src'));
        v.addEventListener('loadeddata', function () { slide.classList.add('pv-hg-vready'); });
        /* Drive the play glyph off the video's real state, so it is always truthful about whether
           tapping will start or stop it. */
        var tog = slide.querySelector('[data-pv-hg-toggle]');
        function markState(playing) {
          slide.classList.toggle('pv-hg-vplaying', playing);
          if (tog) tog.setAttribute('aria-label', playing ? 'Pause this video' : 'Play this video');
        }
        v.addEventListener('play', function () { markState(true); });
        v.addEventListener('pause', function () { markState(false); });
        v.addEventListener('ended', function () { markState(false); });
        slide.appendChild(v);
        return v;
      }
      function hgStopAll(except) {
        for (var s = 0; s < slides.length; s++) {
          if (slides[s] === except) continue;
          var ov = slides[s].querySelector('video');
          if (ov) { ov.pause(); ov.muted = true; slides[s].classList.remove('pv-hg-vsound'); }
        }
      }
      /* NO AUTOPLAY in the hero (owner 2026-09-07: on a phone the muted auto-start meant a first tap
         paused it and a second tap started it with sound, "so let's just have a play button in the
         middle"). A video slide now arrives on its poster with a play glyph; one tap on the slide
         starts it WITH sound (the tap is the user gesture browsers require for audio) and the glyph
         goes while it plays. Arriving at the slide only builds the element, so the tap is instant.
         The video wall lower down keeps its own silent-preview behaviour on purpose. */
      function hgPrep(slide) { hgVideo(slide); }
      function hgPlay(slide) {
        var v = hgVideo(slide); if (!v) return;
        v.preload = 'auto';
        v.muted = false;
        slide.classList.add('pv-hg-vsound');
        var pr = v.play();
        if (pr && pr.catch) pr.catch(function () {
          /* the browser refused audio even inside a tap: play silently rather than freeze on a frame */
          v.muted = true; slide.classList.remove('pv-hg-vsound');
          var p2 = v.play(); if (p2 && p2.catch) p2.catch(function () {});
        });
      }
      /* Tap the slide (the centre glyph, the poster or the bottom-right button) to start it with sound;
         tap again to stop it. */
      track.addEventListener('click', function (e) {
        var slide = e.target.closest ? e.target.closest('.pv-hg-slide--video') : null;
        if (!slide) return;
        var v = hgVideo(slide); if (!v) return;
        e.preventDefault();
        if (!v.paused) { v.pause(); v.muted = true; slide.classList.remove('pv-hg-vsound'); }
        else hgPlay(slide);
      });
      /* Keep the active thumbnail in view. Deliberately only scrolls when the thumb is actually out
         of view, so the rail sits still near the start and only begins travelling once the active one
         reaches an edge (owner 2026-09-06). scrollLeft is set directly rather than via
         scrollIntoView, which would also scroll the PAGE and yank the customer around. */
      var thumbRail = gallery.querySelector('.pv-hg-thumbs');
      function keepThumbInView(i) {
        var t = thumbs[i];
        if (!thumbRail || !t || thumbRail.scrollWidth <= thumbRail.clientWidth) return;
        var pad = 26;
        var tl = t.offsetLeft, tr = tl + t.offsetWidth;
        var vl = thumbRail.scrollLeft, vr = vl + thumbRail.clientWidth;
        var to = null;
        if (tl - pad < vl) to = Math.max(0, tl - pad);
        else if (tr + pad > vr) to = tr + pad - thumbRail.clientWidth;
        if (to === null) return;
        if (thumbRail.scrollTo) thumbRail.scrollTo({ left: to, behavior: 'smooth' });
        else thumbRail.scrollLeft = to;
      }
      /* Slow drift of the thumbnail rail (owner 2026-09-06: "after around five seconds, these
         thumbnails could very slowly, very slowly start moving along"). Its whole job is to reveal
         that the row carries on past the edge. Starts 5s in, moves at 12px a second, and gives up the
         moment the customer touches the gallery: it must never fight someone who is already looking.
         Also idles while the hero is off screen, and is skipped for prefers-reduced-motion. */
      var driftRAF = null, driftDelay = null, driftLast = 0, driftDone = false, driftReduce = false;
      try { driftReduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
      function driftStep(ts) {
        if (driftDone || !thumbRail) return;
        if (!driftLast) driftLast = ts;
        var dt = ts - driftLast; driftLast = ts;
        var max = thumbRail.scrollWidth - thumbRail.clientWidth;
        if (max <= 0) { driftDone = true; return; }
        thumbRail.scrollLeft = Math.min(max, thumbRail.scrollLeft + (12 * dt) / 1000);
        if (thumbRail.scrollLeft >= max - 0.5) { driftDone = true; return; }
        driftRAF = requestAnimationFrame(driftStep);
      }
      function driftCancel(forGood) {
        clearTimeout(driftDelay);
        if (driftRAF) cancelAnimationFrame(driftRAF);
        driftRAF = null; driftLast = 0;
        if (forGood) driftDone = true;
      }
      function driftStart() {
        if (driftDone || driftReduce || !thumbRail || driftRAF) return;
        clearTimeout(driftDelay);
        driftDelay = setTimeout(function () { driftLast = 0; driftRAF = requestAnimationFrame(driftStep); }, 5000);
      }
      /* Any real interest from the customer ends it for good. */
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) {
        gallery.addEventListener(ev, function () { driftCancel(true); }, { passive: true });
      });
      function setActive(i) {
        dots.forEach(function (d, j) { d.classList.toggle('pv-active', j === i); });
        for (var t = 0; t < thumbs.length; t++) { thumbs[t].classList.toggle('pv-active', t === i); }
        keepThumbInView(i);
        gallery.setAttribute('data-active-slide', i);
        var cur = slides[i];
        hgStopAll(cur);
        if (cur && cur.hasAttribute('data-pv-hg-video')) hgPrep(cur);   /* ready, not playing */
      }
      gallery.setAttribute('data-active-slide', '0');
      // Infinite forward loop: a clone of the first slide sits after the last. Swiping (or tapping the
      // arrow) past the end lands on the copy of slide 1, then we instantly snap back to the real first
      // slide, so the customer can keep going round. `count` stays the real slide count (dots/idx).
      var loopClone = slides[0].cloneNode(true);
      loopClone.setAttribute('aria-hidden', 'true');
      loopClone.setAttribute('data-pv-clone', '1');
      /* If slide 1 were ever a video, the clone would carry its markup but sits outside `slides`, so
         nothing would ever pause it. Strip the video bits so the clone can only ever be a still. */
      loopClone.removeAttribute('data-pv-hg-video');
      loopClone.querySelectorAll('video').forEach(function (n) { n.remove(); });
      track.appendChild(loopClone);
      function goTo(i, user) {
        idx = (i + count) % count;
        track.scrollTo({ left: idx * slideW(), behavior: 'smooth' });
        setActive(idx);
        if (user) restart();
      }
      function start() { /* auto-rotate disabled: the gallery only advances when the customer swipes or taps the arrow */ }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function restart() { stop(); start(); }
      var st;
      track.addEventListener('scroll', function () {
        clearTimeout(st);
        st = setTimeout(function () {
          var i = Math.round(track.scrollLeft / slideW());
          if (i >= count) { track.scrollTo({ left: 0, behavior: 'auto' }); idx = 0; setActive(0); return; } // landed on the clone -> snap to real slide 1
          if (i !== idx) { idx = i; setActive(idx); }
        }, 90);
      }, { passive: true });
      ['touchstart', 'pointerdown', 'mouseenter'].forEach(function (ev) { track.addEventListener(ev, stop, { passive: true }); });
      ['touchend', 'pointerup', 'mouseleave'].forEach(function (ev) { track.addEventListener(ev, restart, { passive: true }); });
      var prevBtn = gallery.querySelector('.pv-hg-prev'), nextBtn = gallery.querySelector('.pv-hg-next');
      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(idx - 1, true); });
      if (nextBtn) nextBtn.addEventListener('click', function () {
        if (idx >= count - 1) { track.scrollTo({ left: count * slideW(), behavior: 'smooth' }); } // forward onto the clone; the scroll handler snaps back to slide 1
        else { goTo(idx + 1, true); }
      });
      if ('IntersectionObserver' in window) {
        var gio = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (e.isIntersecting) {
              start();
              driftStart();
              /* Back on screen: the slide waits on its poster with the play glyph; nothing starts on its own. */
              var cur = slides[idx];
              if (cur && cur.hasAttribute('data-pv-hg-video')) hgPrep(cur);
            } else {
              stop();
              driftCancel(false);
              /* SCROLLED AWAY: stop it. A customer who scrolls on down the page must not be followed
                 by a voice from a gallery they can no longer see (owner: "they can scroll off it").
                 Muted as well as paused, so it never resumes talking on its own. */
              hgStopAll(null);
            }
          });
        }, { threshold: 0.3 });
        gio.observe(gallery);
      } else { start(); driftStart(); }
    })();

    // -- Clone the top trust-pill row into the mid + bottom slots --
    (function () {
      var top = document.querySelector('nav.pv-trust-top');
      if (!top) return;
      var html = top.innerHTML;
      document.querySelectorAll('[data-pv-trust-clone]').forEach(function (c) { c.innerHTML = html; });
    })();

    // Landing pages only. The funnel keeps its own framing below, untouched.
    var PV_LP = document.documentElement.classList.contains('pv-lp');

    // Frame the buy zone on mobile when a plan is picked.
    //
    // ANCHOR: the TOP OF THE FIRST CARD, a few pixels below the top of the screen (owner 2026-07-28: "I
    // wanted the page to start just above the three month plan, literally a few millimeters"). On variant D
    // the first card IS the 3-Month Plan.
    //
    // Why the first card and not the open one: the first card's top NEVER MOVES, whichever card is open,
    // because everything that expands or collapses sits below it. Measured at 375x812, its top is 8478 in
    // both states. So both cards resolve to the same target, and the 6px guard below then means flipping
    // between the cards computes the same number and does not move the page at all. Scroll away, tap again,
    // and it returns to that same place. Anchoring on the OPEN card (the previous version) was what made the
    // page shift on every switch, since that is a different position for each card.
    //
    // Measured headroom: from the first card's top down to the wallet button's bottom is 790px, so with a
    // 12px lead-in the instant checkout still lands on screen with room to spare.
    function pvFrameCta(section) {
      if (!section) return;
      var stack  = section.querySelector('.pv-pricing-stack');
      var first  = stack && stack.querySelector('[data-pv-option]');
      var wallet = section.querySelector('.pv-express:not(.pv-express--plan-off)') || section.querySelector('.pv-buynow-bar');
      if (!stack || !first || !wallet) return;

      var vh = window.innerHeight || document.documentElement.clientHeight;
      var CARD_PAD = 12, BOTTOM_PAD = 10;
      var cardTop      = first.getBoundingClientRect().top + window.scrollY;
      var walletBottom = wallet.getBoundingClientRect().bottom + window.scrollY;

      var y = cardTop - CARD_PAD;
      // Safety for shorter phones and any future three-card variant: if starting at the card would push the
      // wallet button off the bottom, pin the wallet instead. Being able to pay beats the lead-in.
      if (walletBottom - y > vh - BOTTOM_PAD) y = walletBottom + BOTTOM_PAD - vh;

      var maxY = Math.max(0, document.documentElement.scrollHeight - vh);
      y = Math.max(0, Math.min(y, maxY));

      // Already there: do nothing. This is what stops the page nudging when the customer flips cards.
      if (Math.abs(window.scrollY - y) <= 6) return;

      // MUST be 'instant', NOT 'auto'. 'auto' means "use the element's computed scroll-behavior", and this
      // theme sets scroll-behavior:smooth on <html>, so 'auto' resolves back to smooth, which a browser
      // with prefers-reduced-motion suppresses outright, leaving those customers with no repositioning.
      var reduced = false;
      try { reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
      try { window.scrollTo({ top: y, behavior: reduced ? 'instant' : 'smooth' }); }
      catch (e) { try { window.scrollTo(0, y); } catch (e2) {} }
    }

    // -- Pricing option selection (gold highlight) --------------
    function initOptionGroup(container) {
      var opts = container.querySelectorAll('[data-pv-option]');
      var section = container.closest('.pv-pricing-section');
      var lastAnchorY = null; // scroll position we last settled the cards at (see select())
      var bigBtn = section ? section.querySelector('.pv-buynow-bar') : null;
      // Big "Buy Now" bar: label stays "Buy Now"; the checkout link AND the
      // plan + price subline follow whichever card is highlighted.
      function syncBig(opt) {
        if (!bigBtn) return;
        bigBtn.setAttribute('href', opt.getAttribute('data-pv-href') || '#');
        pvSyncBuyNowSubline();
        /* With every card closed on load (owner 2026-10-15) the button is only put into the card just after this runs,
           so fill its price again once it is on the page. */
        setTimeout(pvSyncBuyNowSubline, 60);
      }
      opts.forEach(function (opt) {
        function select(ev) {
          var wasSelected = opt.classList.contains('pv-selected');
          opts.forEach(function (o) { o.classList.remove('pv-selected'); o.setAttribute('aria-checked', 'false'); });
          opt.classList.add('pv-selected');
          opt.setAttribute('aria-checked', 'true');
          syncBig(opt);
          var pvNarrow = (window.innerWidth || document.documentElement.clientWidth) <= 640;
          var pvIsSub = opt.getAttribute('data-pv-option') === 'subscribe';
          // A tap that came from something interactive inside the card (the "See how to cancel" link,
          // any +/- control) must never yank the page out from under that other action.
          var pvFromControl = !!(ev && ev.target && ev.target.closest && ev.target.closest('a, button, input, select, [data-pv-qty]'));
          var pvSubHead = section && section.querySelector('.pv-plan-grouphead--sub');

          // TAPPING THE SUBSCRIPTION CARD PUTS ITS "Subscribe & save more" HEADING AT THE TOP OF THE
          // SCREEN. Owner 2026-08-08, with a device screenshot of the exact target framing.
          //
          // This block sits ABOVE the PV_LP branch on purpose, and that placement IS the fix. It was
          // first written below it, which meant it only ever ran on the funnel: on the landing page
          // PV_LP is true, so a tap took the pvFrameCta path and RETURNED before reaching this code.
          // pvFrameCta frames the wallet button, not the group heading, so on the ad landing page
          // nothing looked like it had changed at all ("its not live on the energy sales page on the
          // ads"). The subscribe card now frames identically on both pages; every other card keeps
          // the per-page behaviour below.
          //
          // It also sits OUTSIDE the !wasSelected gate on purpose: the subscription card opens BY
          // DEFAULT on arrival (2026-08-06), so a tap on it is nearly always a re-tap of an
          // already-selected card, and gating on !wasSelected meant the plan most people buy was the
          // one plan that never framed itself.
          if (pvNarrow && pvIsSub && !pvFromControl && pvSubHead) {
            var pvFrameSub = function (instant) {
              var sy = Math.max(0, pvSubHead.getBoundingClientRect().top + window.scrollY - 16);
              // never ask for a position the document cannot reach, or the settle-correct below would
              // keep re-firing against a target it can never satisfy
              var maxY = Math.max(0, document.documentElement.scrollHeight - (window.innerHeight || document.documentElement.clientHeight || 0));
              if (sy > maxY) sy = maxY;
              lastAnchorY = sy;
              if (Math.abs(window.scrollY - sy) <= 6) return;
              // MUST be 'instant', NOT 'auto', when motion is reduced: 'auto' means "use the computed
              // scroll-behavior", and this theme sets scroll-behavior:smooth on <html>, so 'auto'
              // resolves back to smooth, which a browser with prefers-reduced-motion suppresses
              // OUTRIGHT. That would leave exactly those customers with no repositioning at all: the
              // same trap pvFrameCta documents, which this code originally walked straight into.
              var reduced = false;
              try { reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
              try { window.scrollTo({ top: sy, behavior: (instant || reduced) ? 'instant' : 'smooth' }); }
              catch (e) { try { window.scrollTo(0, sy); } catch (e2) {} }
            };
            // Twice, for the same reason the LP path runs pvFrameCta twice: the card height is a 350ms
            // max-height transition, so a single pass timed near the end of it can measure a card that
            // is still growing. The second pass re-measures once settled; the >6px guard makes it a
            // no-op when the first pass was already right.
            setTimeout(function () { pvFrameSub(false); }, 380);
            setTimeout(function () { pvFrameSub(false); }, 780);
            // ...and once more after the scroll has actually STOPPED, this time INSTANT. Both passes
            // above measure while the smooth scroll is still travelling, which is exact for a short
            // hop (the normal case: the customer taps a card already on screen) but can go stale over
            // a long one, because lazy images loading on the way past change the height of everything
            // above the target. Measured 2026-08-08: tapping from the very top of the funnel overshot
            // by 389px. Instant here also means an in-app browser that quietly drops a smooth scroll
            // mid-flight still ends up in the right place. Idempotent: the >6px guard means a correct
            // landing does not move the page at all.
            (function settleThenCorrect(){
              var last = -1, still = 0, tries = 0;
              var iv = setInterval(function(){
                var y = Math.round(window.scrollY);
                if (y === last) still++; else { still = 0; last = y; }
                if (still >= 2 || ++tries > 30){ clearInterval(iv); pvFrameSub(true); }
              }, 110);
            })();
            return;
          }

          if (PV_LP) {
            if (!pvNarrow) return;
            if (pvFromControl) return;
            // Fires on a re-tap of the already-open card too: on the LP the subscribe card is open on
            // arrival, so gating on !wasSelected would mean the default plan never frames its checkout.
            // Run it TWICE. The card height is a 350ms max-height transition, so a single pass timed near
            // the end of it can measure a card that is still growing and land the page slightly off. The
            // second pass re-measures once everything has settled and corrects it. It is idempotent: if the
            // first pass was already right, the >6px guard inside pvFrameCta makes the second a no-op.
            setTimeout(function () { pvFrameCta(section); }, 420);
            setTimeout(function () { pvFrameCta(section); }, 840);
            return;
          }

          // When a card opens, frame it. Mobile only. Held stable when switching cards.
          if (!wasSelected && pvNarrow) {
            setTimeout(function () {
              // If the customer hasn't scrolled since we last settled, DON'T move -- switching cards
              // holds the same position. Re-anchors only on first open or after they scroll away.
              if (lastAnchorY != null && Math.abs(window.scrollY - lastAnchorY) <= 6) return;
              var topPad = 6, bottomPad = 10;
              var vh = window.innerHeight || document.documentElement.clientHeight;
              // Anchor the TOP of the stack just under the screen top so every card is in view. The
              // stack top is the SAME element whichever card is open, so switching cards resolves to
              // the SAME scroll position -> the screen does not jump. If the block is taller than the
              // screen, all cards still show from the top and the checkout flows in just below
              // (Buy Now visible; Apple Pay may sit a touch under the fold).
              var stackEl = section && section.querySelector('.pv-pricing-stack');
              var express = section && section.querySelector('.pv-express');
              var buynow = section && section.querySelector('.pv-buynow-bar');
              if (!stackEl) return;
              var stackTop = stackEl.getBoundingClientRect().top;
              var ctaEl = (express && express.offsetHeight) ? express : buynow;
              var ctaBottom = ctaEl ? ctaEl.getBoundingClientRect().bottom : stackEl.getBoundingClientRect().bottom;
              var blockH = ctaBottom - stackTop;
              var avail = vh - topPad - bottomPad;
              var delta = (blockH <= avail) ? (stackTop - (topPad + (avail - blockH) / 2)) : (stackTop - topPad);
              if (Math.abs(delta) > 6) { window.scrollBy({ top: delta, behavior: 'smooth' }); lastAnchorY = window.scrollY + delta; }
              else { lastAnchorY = window.scrollY; }
            }, 380);
          }
        }
        opt.addEventListener('click', select);
        opt.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(); } });
      });
      // initialise the big bar from whichever card starts selected
      var pre = container.querySelector('[data-pv-option].pv-selected') || opts[0];
      /* Google Shopping page (owner via Houston 2026-10-12): every card starts closed so the per-bottle prices
         compare at a glance. Until a card is tapped, Buy Now reads "Choose an option above" (the template's
         buynow_plan) and a tap on it brings the cards into view instead of opening any checkout. */
      if (section && section.hasAttribute('data-pv-google') && !container.querySelector('[data-pv-option].pv-selected')) {
        if (bigBtn) {
          bigBtn.setAttribute('href', '#pricing');
          bigBtn.addEventListener('click', function (e) {
            if (container.querySelector('[data-pv-option].pv-selected')) return;
            e.preventDefault(); e.stopImmediatePropagation();
            try { opts[0].scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (err) {}
            container.classList.remove('pv-choose-nudge'); void container.offsetWidth; container.classList.add('pv-choose-nudge');
          }, true);
        }
      } else if (pre) syncBig(pre);
    }
    // Buy Now subline = selected plan name + its CURRENT "Total to pay" (so it reflects WELCOME10 too,
    // e.g. "1 Bottle  ·  £19.80"). Reads the live receipt total off the selected card. Shared so both
    // card-selection (syncBig) and the WELCOME10 module can refresh it.
    function pvSyncBuyNowSubline() {
      var bar = document.getElementById('pv-buynow');
      if (!bar) return;
      var planEl = bar.querySelector('.pv-buynow-plan');
      if (!planEl) return;
      var sel = document.querySelector('.pv-pricing-stack .pv-option.pv-selected');
      if (!sel) return;
      var name = sel.getAttribute('data-pv-plan') || '';
      var totalEl = sel.querySelector('.pv-receipt-total-row span:last-child');
      var total = totalEl ? totalEl.textContent.trim() : '';
      planEl.textContent = total ? (name + ' · ' + total) : name;
      /* Owner 2026-10-15: "we should have the price in the buy now too". Where the plan line under Buy Now is hidden
         (the sales page and the energy LPs), the selected card's live total goes inside the button: "Buy Now · £38.25". */
      var main = bar.querySelector('.pv-buynow-main');
      if (main && !bar.classList.contains('pv-going')) {
        var bp = main.querySelector('.pv-buynow-price');
        if (planEl.getClientRects().length === 0 && total) {   /* hidden, or not placed on the page yet (all cards start closed) */
          if (!bp) { bp = document.createElement('span'); bp.className = 'pv-buynow-price';
            var arrow = main.querySelector('.pv-buynow-arrow'); main.insertBefore(bp, arrow || null); }
          bp.textContent = ' \u00b7 ' + total;
          /* Owner 2026-10-15: what they are buying, small and lighter under the button. Supply for one-offs, the plan by name. */
          var what = bar.querySelector('.pv-buynow-what');
          if (!what) { what = document.createElement('span'); what.className = 'pv-buynow-what'; bar.appendChild(what); }
          var isPlan = sel.getAttribute('data-pv-option') === 'subscribe';
          var sup = sel.querySelector('.pv-supply');
          what.textContent = isPlan ? ('Renews at \u00a3' + (parseFloat(sel.getAttribute('data-pv-total')) || 45) + ' every 3 months \u00b7 cancel any time') : ((sup ? sup.textContent.trim() + ' \u00b7 ' : '') + 'One-time purchase');   /* owner: one-time purchase next to the supply */
          /* Owner 2026-10-15: trust at the moment of decision. The delivery promise and the guarantee row sit right under
             Buy Now inside the open card (moved with it when another card opens), instead of in separate blocks below. */
          var trust = document.querySelector('.pv-buy-trust');
          if (!trust) {
            trust = document.createElement('div'); trust.className = 'pv-buy-trust';
            var etaB = document.querySelector('#pricing .pv-eta-main b');
            /* the date now sits in each card's "Free delivery" line (owner 2026-10-15: "too much writing") */
            if (etaB) document.querySelectorAll('#pricing .pv-receipt-shipping-row span:last-child').forEach(function (sp) {
              if (!sp.hasAttribute('data-pv-ship-eta')) { sp.setAttribute('data-pv-ship-eta', ''); sp.innerHTML = '<svg class="pv-ship-ic" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 17h4V5H2v12h3"/><path d="M20 17h2v-3.34a4 4 0 0 0-1.17-2.83L19 9h-5v8h1"/><circle cx="7.5" cy="17.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/></svg><span>Free delivery \u00b7 most arrive by </span><span class="pv-ship-dot" aria-hidden="true"></span><b class="pv-ship-date"></b>'; sp.querySelector('.pv-ship-date').textContent = etaB.textContent; }
            });
            if (false) {
              var el = document.createElement('p'); el.className = 'pv-buy-eta';
              el.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 17h4V5H2v12h3"/><path d="M20 17h2v-3.34a4 4 0 0 0-1.17-2.83L19 9h-5v8h1"/><circle cx="7.5" cy="17.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/></svg><span>Order today, most orders arrive by <b></b></span>';
              el.querySelector('b').textContent = etaB.textContent; trust.appendChild(el);
            }
            var grow = document.querySelector('#pricing .pv-guarantee-row'); if (grow) trust.appendChild(grow);
            /* Owner 2026-10-15 ("not enough trust value... add the reviews under, like the made in britain and purity
               tested"): rating, Made in Britain and Purity tested as small pills under the guarantee line. The rating
               and count are read from the hero, so they never drift from the real figure. */
            var pills = document.createElement('div'); pills.className = 'pv-buy-pills';
            var rt = document.querySelector('.pv-h1-rating'); var m = rt && rt.textContent.match(/([\d.]+)\s*\/\s*5[^\d]*([\d,]+)/);
            if (m) { var rp = document.createElement('a'); rp.className = 'pv-buy-rating'; rp.href = rt.getAttribute('href') || '#reviews';
              rp.innerHTML = '<span class="pv-bq-stars" aria-hidden="true">\u2605\u2605\u2605\u2605\u2605</span> ' + m[1] + ' from ' + m[2] + ' reviews'; trust.appendChild(rp); }
            ['britain', 'purity'].forEach(function (k) { var src = document.querySelector('.pv-hero .pv-trust-pill--' + k); if (src) pills.appendChild(src.cloneNode(true)); });
            if (pills.children.length) trust.appendChild(pills);
          }
          if (trust.previousElementSibling !== bar) bar.insertAdjacentElement('afterend', trust);
          /* Owner 2026-10-15: "these look like buttons... a circle top right saying the % off". The open card's saving as a
             round badge in its head; the gold bar is hidden. Read from the bar, so codes and offers stay in step. */
          document.querySelectorAll('#pricing .pv-save-badge').forEach(function (b) { if (!sel.contains(b)) b.remove(); });
          var sbar = sel.querySelector('.pv-save-bar'), pm = sbar && sbar.textContent.match(/(\d+)\s*%/);
          var head = sel.querySelector('.pv-option-head'), badge = head && head.querySelector('.pv-save-badge');
          if (pm && head) { if (!badge) { badge = document.createElement('span'); badge.className = 'pv-save-badge'; head.appendChild(badge); }
            badge.innerHTML = '<b>' + pm[1] + '%</b><span>OFF</span>'; } else if (badge) badge.remove();
          /* Owner 2026-10-15: "Our subscription promise" at the bottom of the plan card, under the guarantee line. */
          var prom = sel.querySelector('.pv-promise-link');
          if (prom && trust.parentElement && trust.nextElementSibling !== prom) trust.insertAdjacentElement('afterend', prom);
        } else if (bp) { bp.remove(); }
      }
    }
    document.querySelectorAll('[role="radiogroup"]').forEach(initOptionGroup);

    /* WALLET FALLBACK: guarantee exactly one route to the full checkout, never zero.
       We hide our own "More buying options" link because Shopify renders its own "More payment options"
       inside <shopify-accelerated-checkout>. But that element only renders when the browser actually
       offers a wallet. With no wallet AND a code applied (which hides the discount toggle), .pv-sec-row
       was left empty and there was no link to the full checkout at all: reported by the owner
       2026-09-01 as "more payment options disappear when code applied".
       So: if no accelerated checkout has actually rendered anything, mark #pricing .pv-no-wallet and the
       stylesheet puts our link back. Re-checked after card switches, because the single accelerated
       element is MOVED into whichever card is open, and on a delay because Shopify renders it async. */
    (function () {
      var pricing = document.getElementById('pricing');
      if (!pricing) return;
      /* Test for a VISIBLE "more payment options" LINK, not merely a rendered wallet. The first version
         of this checked the wallet, which was wrong in a way that mattered: pv-lp.css deliberately hides
         Shopify's link on the energy LP
           #pv-buybar, #pricing .pv-code-entry, #pricing .shopify-payment-button__more-options,
           #pricing #more-payment-options-link { display:none !important; }
         so the LP has ALWAYS relied on our link being the single one. A wallet renders there, so a
         wallet-based check kept ours hidden and left the LP with no route to the full checkout at all.
         Shopify renders its link inside an OPEN shadow root, so it has to be walked rather than queried. */
      function moreOptionsLinkVisible() {
        var found = false;
        function walk(node) {
          if (found || !node) return;
          if (node.shadowRoot) walk(node.shadowRoot);
          var kids = node.children || node.childNodes;
          if (!kids) return;
          for (var i = 0; i < kids.length; i++) {
            var el = kids[i];
            if (el.nodeType !== 1) continue;
            if (el.id === 'more-payment-options-link' ||
                (el.className && String(el.className).indexOf('more-options') > -1)) {
              var r = el.getBoundingClientRect();
              if (r.width > 0 && r.height > 0) { found = true; return; }
            }
            walk(el);
            if (found) return;
          }
        }
        walk(pricing);
        return found;
      }
      /* Owner 2026-09-09: since 2026-09-07 the row carries a PROXY link (.pv-mpo-link, built in theme.liquid)
         that forwards to Shopify's link, which is hidden by design. Counting only Shopify's own link as
         "visible" made this fallback fire on every wallet browser and resurrect the old gold bar under the
         proxy, on a second line: "More buying options" under "More payment options". A visible proxy IS a
         route to the full checkout, so it satisfies the check. */
      function proxyLinkVisible() {
        var m = pricing.querySelector('.pv-mpo-link');
        if (!m || m.hidden) return false;
        var r = m.getBoundingClientRect();
        return r.width > 0 && r.height > 0;
      }
      function sync() { pricing.classList.toggle('pv-no-wallet', !(moreOptionsLinkVisible() || proxyLinkVisible())); }
      sync();
      [400, 1200, 3000].forEach(function (ms) { setTimeout(sync, ms); });
      pricing.addEventListener('click', function () { setTimeout(sync, 250); });
      if (window.MutationObserver) {
        new MutationObserver(function () { sync(); })
          .observe(pricing, { childList: true, subtree: true });
      }
    })();

    // -- Limited-time offer countdown (GENUINE). Counts down to a FIXED end date (same for every
    //    visitor, no per-visit reset) that MATCHES the 1-bottle 12% automatic discount's real expiry.
    //    While live: shows "ends in Xd Xh Xm Xs". At zero: hides the banner AND reverts the 1-bottle
    //    card to full price (£25) so the page can NEVER show £22 while checkout charges £25 (fail-safe).
    //    2026-10-11: one bar per offer. data-pv-offer-card says which card a bar governs: 'single' (the
    //    1-bottle sale, default) or 'triple' (the 3-bottle one-off offer, snippets/pv-offer-triple-end.liquid).
    (function () {
      var bars = document.querySelectorAll('.pv-offer-bar[data-pv-offer-end]');
      if (!bars.length) return;
      function revertOneBottle() {
        var card = document.querySelector('[data-pv-option="single"]');
        if (!card) return;
        card.setAttribute('data-pv-total', '25');
        var pn = card.querySelector('.pv-price-new');
        if (pn) { var permo = pn.querySelector('.pv-price-permo'); pn.textContent = '£25'; if (permo) pn.appendChild(permo); }
        [['.pv-price-was'], ['.pv-price-save'], ['.pv-save-bar'], ['.pv-receipt-was-row'], ['.pv-receipt-save-row']].forEach(function (s) {
          var el = card.querySelector(s[0]); if (el) el.style.display = 'none';
        });
        var per = card.querySelector('.pv-price-per'); if (per) per.textContent = '1-month supply · 83p a day';
        var tv = card.querySelector('.pv-receipt-total-row span:last-child'); if (tv) tv.textContent = '£25';
        /* innerHTML, not textContent: the per-day line contains the [data-pv-perday-now] span that the
           discount-code module writes into. textContent would delete it, and a code-holder's per-day
           figure would then be frozen at the sale price for the rest of the session. */
        var pd = card.querySelector('.pv-receipt-perday');
        if (pd) pd.innerHTML = 'Just <span class="pv-perday-now" data-pv-perday-now>83p</span> a day';
        if (card.classList.contains('pv-selected')) { var bp = document.querySelector('.pv-buynow-price'); if (bp) bp.textContent = ' · £25'; }
        /* THE CODE-HOLDER CASE. Everything above resets the card to the full price, but a customer with
           a discount code on the session has already had their receipt computed off the SALE price, and
           the promo module caches that figure in data-pv-base-total. Without republishing it and asking
           for a recompute, the card would sit at "Total to pay £18" (£20 less 10%) while checkout
           charges £22.50 (£25 less 10%): the same display-vs-charge defect fixed in 594W, just triggered
           by the clock instead of by a code. Republish the post-sale base and re-run.
           Safe when no code is applied: the pv:price-updated listener only exists once a promo is live. */
        var banner = card.querySelector('.pv-total-banner');
        if (banner) banner.setAttribute('data-pv-base-total', '25');
        document.dispatchEvent(new CustomEvent('pv:price-updated'));
      }
      /* The 3-bottle offer's card carries its stored state in data-pv-offer-revert, rendered by pv-pricing.liquid
         from the template's own values, so no price is typed twice. At zero it goes back to that state, and, as in
         revertOneBottle, a code-holder's receipt is recomputed from the restored base. */
      function revertCard(key) {
        var card = document.querySelector('[data-pv-option="' + key + '"][data-pv-offer-revert]');
        if (!card) return;
        var r; try { r = JSON.parse(card.getAttribute('data-pv-offer-revert')); } catch (e) { return; }
        card.removeAttribute('data-pv-offer-revert');
        card.setAttribute('data-pv-total', String(r.total));
        var pn = card.querySelector('.pv-price-new');
        if (pn) { var permo = pn.querySelector('.pv-price-permo'); pn.textContent = r.price; if (permo) pn.appendChild(permo); }
        card.querySelectorAll('.pv-price-save, .pv-save-bar').forEach(function (el) { if (r.save) el.textContent = r.save; });
        var pdh = card.querySelector('.pv-per-day'); if (pdh && r.perday) pdh.textContent = ' \u00b7 ' + r.perday;
        var sr = card.querySelector('.pv-receipt-save-row');
        if (sr) { var sp = sr.querySelectorAll('span'); if (sp.length > 1) { sp[0].textContent = r.disc; sp[sp.length - 1].textContent = r.saveamt; } }
        var tv = card.querySelector('.pv-receipt-total-row span:last-child'); if (tv) tv.textContent = '£' + r.total;
        card.querySelectorAll('.pv-receipt-perday').forEach(function (pd) { pd.innerHTML = 'Just <span class="pv-perday-now" data-pv-perday-now>' + r.pd + '</span> a day'; });
        if (card.classList.contains('pv-selected')) { var bp = document.querySelector('.pv-buynow-price'); if (bp) bp.textContent = ' · £' + r.total; }
        var banner = card.querySelector('.pv-total-banner');
        if (banner) banner.setAttribute('data-pv-base-total', String(r.total));
        document.dispatchEvent(new CustomEvent('pv:price-updated'));
      }
      Array.prototype.forEach.call(bars, function (bar) {
        var end = new Date(bar.getAttribute('data-pv-offer-end')).getTime();
        if (isNaN(end)) return;
        var key = bar.getAttribute('data-pv-offer-card') || 'single';
        var cdEl = bar.querySelector('[data-pv-countdown]');
        var ended = false, iv = null;
        function tick() {
          var left = end - Date.now();
          if (left <= 0) { if (!ended) { ended = true; bar.hidden = true; if (iv) clearInterval(iv); if (key === 'single') revertOneBottle(); else revertCard(key); } return; }
          var s = Math.floor(left / 1000);
          var d = Math.floor(s / 86400); s -= d * 86400;
          var h = Math.floor(s / 3600); s -= h * 3600;
          var m = Math.floor(s / 60); s -= m * 60;
          cdEl.textContent = d + 'd ' + h + 'h ' + m + 'm ' + s + 's';
          bar.hidden = false;
        }
        tick();
        if (!ended) iv = setInterval(tick, 1000);
      });
    })();

    // -- Auto-applied discount confirmation: a customer who claimed a code (WELCOME10 / STAYWITH10)
    //    via the email popup or a buyer-flow email is routed here through
    //    /discount/CODE?redirect=...?promo=<code>, which silently applies the code at checkout (incl.
    //    Buy with Shop / Apple Pay, neither of which has a code field). Reveal every confirmation element
    //    (toast, the bar above the cards, the mini line, the per-card receipt rows), fill in the code's
    //    label + %, recompute the receipt, then strip the query param so the URL stays clean.
    (function () {
      /* url ?promo=<value> (or the discount_code cookie) -> { pct, label }. Each stacks an EXTRA % off
         the already-discounted card price (all combinesWith productDiscounts=true; verified live).
         OWNER RULE (decision-log 218): the cards MUST reflect EVERY live discount code. So when ANY new
         PERCENTAGE code is created (any domain), register it here with its EXACT { pct, label } and make
         sure the Shopify code has combinesWith.productDiscounts=true, so what's shown == what's charged.
         A code missing here still discounts at checkout via the cookie but leaves the cards silent.
         (see decision-log 150 / 182 / 215 / 218) */
      /* ALL 9 LIVE CODES (owner 2026-08-20: "keep them live and put all of them live on the discount
         box, so they're all valid"). The box previously knew only the first two, so it told customers
         that seven genuinely live codes were invalid, including COMEBACK10 on abandoned-cart emails and
         THANKYOU10 on parcel inserts, both sitting at 0 redemptions.
         OWNER DECISION, RECORDED: this file is a PUBLIC asset, so listing codes here publishes them to
         anyone who views source. That was put to the owner explicitly, including that JACKSONTEST90 is a
         90% code, and the answer was "I'm fine with the code being on the website, because I can just
         decline the orders." Their call, taken with the risk stated.
         `combines` mirrors Shopify's combinesWith.productDiscounts, read from the Admin API on
         2026-08-20, and it is the important field. TRUE codes stack on top of the bulk/selling-plan
         discount, so the card receipt can show base + extra and land the real charged total. FALSE codes
         do NOT stack: showing them as an extra on top of the bulk price would print a total the customer
         is not charged, which breaks the standing "what's shown == what's charged" rule. So a
         non-combining code is ACCEPTED and confirmed, but the cards are left at their normal prices and
         the better price appears at checkout. Under-promising beats mis-stating.
         Values verified against the Admin API, not guessed: TRY3! and TRY10! are AMOUNT codes (GBP 22
         and GBP 15 off), which the old percent-only map could never have represented at all. */
      /* `sub` mirrors the code's customerGets.appliesOnSubscription, read from the Admin API on
         2026-09-06. IT IS NOT COSMETIC. Shopify simply refuses a sub:false code on a selling-plan
         cart, so previewing it on the subscription card prints a total the customer is not charged.
         Measured live before this was added: the card promised "Total to pay £36" with WELCOMEBACK20
         while the same subscription cart checked out at £45.00 with no discount attached, a £9 lie on
         the money page. Four stacking codes were affected (COMEBACK10, THANKYOU10, THANKYOU15,
         WELCOMEBACK20). A code registered WITHOUT `sub` is treated as one-time-only, which is the
         direction that can only ever under-promise. Every sub:true code also has recurringCycleLimit
         1, so it discounts the FIRST subscription order and renewals bill the plan price. */
      /* 2026-09-17 (owner: "all should work on subscription as I want to sell the subscription more"): COMEBACK10,
         THANKYOU10, THANKYOU15 and WELCOMEBACK20 were switched in Shopify to cover subscriptions, first cycle
         only, so they are sub:true here. Still one-time only in Shopify, on purpose: RACHEL40%ALL (private),
         TRY3!/TRY10! (trial offers) and JACKSONTEST90. `sub` MUST mirror Shopify: scripts/pv-discount-matrix.py
         proves it against the live checkout and runs daily. */
      var CODES = {
        welcome10:      { pct: 10,    label: 'WELCOME10',     combines: true,  sub: true },
        /* STAYWITH10 goes to people who have already bought (owner via Houston 2026-10-15), so the bar says "your order", not "your first order". */
        staywith10:     { pct: 10,    label: 'STAYWITH10',    combines: true,  sub: true, anyOrder: true },
        /* Nine personal 15% codes (PV-3, owner's own emails, 15 Oct; Admin API read the same day): one named customer each, one use,
           1 bottle, 3 bottles and the plan's first delivery, combine with product discounts, end 2026-10-29T23:59:59Z. */
        ahoua15:        { pct: 15,    label: 'AHOUA15', combines: true,  sub: true, anyOrder: true, ends: '2026-10-29T23:59:59Z' },
        bev15:          { pct: 15,    label: 'BEV15', combines: true,  sub: true, anyOrder: true, ends: '2026-10-29T23:59:59Z' },
        jacqueline15:   { pct: 15,    label: 'JACQUELINE15', combines: true,  sub: true, anyOrder: true, ends: '2026-10-29T23:59:59Z' },
        caroline15:     { pct: 15,    label: 'CAROLINE15', combines: true,  sub: true, anyOrder: true, ends: '2026-10-29T23:59:59Z' },
        elizabeth15:    { pct: 15,    label: 'ELIZABETH15', combines: true,  sub: true, anyOrder: true, ends: '2026-10-29T23:59:59Z' },
        tess15:         { pct: 15,    label: 'TESS15', combines: true,  sub: true, anyOrder: true, ends: '2026-10-29T23:59:59Z' },
        roscoe15:       { pct: 15,    label: 'ROSCOE15', combines: true,  sub: true, anyOrder: true, ends: '2026-10-29T23:59:59Z' },
        chris15:        { pct: 15,    label: 'CHRIS15', combines: true,  sub: true, anyOrder: true, ends: '2026-10-29T23:59:59Z' },
        lea15:          { pct: 15,    label: 'LEA15', combines: true,  sub: true, anyOrder: true, ends: '2026-10-29T23:59:59Z' },
        /* Batch 2 of the personal 15% check-in codes (PV-3, owner via Houston, 2 Nov; Admin API read the same day): 15% on
           1 bottle, 3 bottles and the plan's first delivery, combine with product discounts, once per customer, end
           2026-11-09T23:59:59Z. The first four have existed since 22 Oct; the rest start 2026-11-02T16:00Z.
           mag: true = the code also takes 15% off magnesium at checkout (Storefront check 2 Nov: £12.75 and £33.15), so the
           magnesium pre-order cards show it too (owner in chat 2 Nov: "I want the magnesium to show the 15% off as well"). */
        angela15:       { pct: 15,    label: 'ANGELA15', combines: true,  sub: true, anyOrder: true, ends: '2026-11-09T23:59:59Z', mag: true },
        catherine15:    { pct: 15,    label: 'CATHERINE15', combines: true,  sub: true, anyOrder: true, ends: '2026-11-09T23:59:59Z', mag: true },
        kate15:         { pct: 15,    label: 'KATE15', combines: true,  sub: true, anyOrder: true, ends: '2026-11-09T23:59:59Z', mag: true },
        laura15:        { pct: 15,    label: 'LAURA15', combines: true,  sub: true, anyOrder: true, ends: '2026-11-09T23:59:59Z', mag: true },
        ayesha15:       { pct: 15,    label: 'AYESHA15', combines: true,  sub: true, anyOrder: true, ends: '2026-11-09T23:59:59Z', mag: true },
        carole15:       { pct: 15,    label: 'CAROLE15', combines: true,  sub: true, anyOrder: true, ends: '2026-11-09T23:59:59Z', mag: true },
        dean15:         { pct: 15,    label: 'DEAN15', combines: true,  sub: true, anyOrder: true, ends: '2026-11-09T23:59:59Z', mag: true },
        janet15:        { pct: 15,    label: 'JANET15', combines: true,  sub: true, anyOrder: true, ends: '2026-11-09T23:59:59Z', mag: true },
        jason15:        { pct: 15,    label: 'JASON15', combines: true,  sub: true, anyOrder: true, ends: '2026-11-09T23:59:59Z', mag: true },
        richard15:      { pct: 15,    label: 'RICHARD15', combines: true,  sub: true, anyOrder: true, ends: '2026-11-09T23:59:59Z', mag: true },
        mohafiz15:      { pct: 15,    label: 'MOHAFIZ15', combines: true,  sub: true, anyOrder: true, ends: '2026-11-09T23:59:59Z', mag: true },
        neil15:         { pct: 15,    label: 'NEIL15', combines: true,  sub: true, anyOrder: true, ends: '2026-11-09T23:59:59Z', mag: true },
        keith15:        { pct: 15,    label: 'KEITH15', combines: true,  sub: true, anyOrder: true, ends: '2026-11-09T23:59:59Z', mag: true },
        clive15:        { pct: 15,    label: 'CLIVE15', combines: true,  sub: true, anyOrder: true, ends: '2026-11-09T23:59:59Z', mag: true },
        iain15:         { pct: 15,    label: 'IAIN15', combines: true,  sub: true, anyOrder: true, ends: '2026-11-09T23:59:59Z', mag: true },
        kelly15:        { pct: 15,    label: 'KELLY15', combines: true,  sub: true, anyOrder: true, ends: '2026-11-09T23:59:59Z', mag: true },
        vivien15:       { pct: 15,    label: 'VIVIEN15', combines: true,  sub: true, anyOrder: true, ends: '2026-11-09T23:59:59Z', mag: true },
        jude15:         { pct: 15,    label: 'JUDE15', combines: true,  sub: true, anyOrder: true, ends: '2026-11-09T23:59:59Z', mag: true },
        carolinel15:    { pct: 15,    label: 'CAROLINEL15', combines: true,  sub: true, anyOrder: true, ends: '2026-11-09T23:59:59Z', mag: true },
        zbigniew15:     { pct: 15,    label: 'ZBIGNIEW15', combines: true,  sub: true, anyOrder: true, ends: '2026-11-09T23:59:59Z', mag: true },
        helen15:        { pct: 15,    label: 'HELEN15', combines: true,  sub: true, anyOrder: true, ends: '2026-11-09T23:59:59Z', mag: true },
        david15:        { pct: 15,    label: 'DAVID15', combines: true,  sub: true, anyOrder: true, ends: '2026-11-09T23:59:59Z', mag: true },
        /* PLAN10, for the newsletter Email sends this week (asked for 2026-09-21, 809W). It is the first code here
           with a life shorter than the page's: the Shopify code stops at 2026-09-28T22:59:59Z while the GBP 20
           one-bottle offer runs to 30 Sep, so without `ends` a stale cookie would light the cards for two days
           against a checkout that refuses it, which is the exact defect the owner banned (775W). `ends` is read
           against SHOPIFY's clock (data-pv-now on the promo bar), not the device's. */
        plan10:         { pct: 10,    label: 'PLAN10',        combines: true,  sub: true, ends: '2026-09-28T22:59:59Z' },
        comeback10:     { pct: 10,    label: 'COMEBACK10',    combines: true,  sub: true },
        thankyou10:     { pct: 10,    label: 'THANKYOU10',    combines: true,  sub: true },
        thankyou15:     { pct: 15,    label: 'THANKYOU15',    combines: true,  sub: true  },
        welcomeback20:  { pct: 20,    label: 'WELCOMEBACK20', combines: true,  sub: true  },
        /* In-box founder cards, live 2026-09-30 (QR -> /discount/<CODE>?redirect=/pages/methylated-b-complex-ultra).
           Both ORDER 10%, combine with product discounts, subscriptions first delivery only (recurringCycleLimit 1).
           Both all customers and reusable (owner 2026-10-01: "never block a sale"). */
      /* `every` (2026-10-01): for codes with recurringCycleLimit unlimited in Shopify; the bar then says it stays on every
           plan delivery and the plan card gets a gold "for good" badge. REVERTED the same afternoon (owner, via HQ-0:
           every code is back to first delivery only), so no code carries `every` now; the code paths stay, inert, in
           case it returns. `anyOrder` (FROMJACKSON10, GIVEAFRIEND10, cards for repeat buyers) makes the bar say
           "10% off your order at checkout" instead of "your first order". `every`/`anyOrder` MUST mirror Shopify. Missing from this map, the page ignored them (owner scanned the QR, 2026-10-01). */
        fromjackson10:  { pct: 10,    label: 'FROMJACKSON10', combines: true,  sub: true, anyOrder: true },
        giveafriend10:  { pct: 10,    label: 'GIVEAFRIEND10', combines: true,  sub: true, anyOrder: true },
        'rachel40%all': { pct: 40,    label: 'RACHEL40%ALL',  combines: false, sub: false },
        'pvfriend20%':  { pct: 20,    label: 'PVFRIEND20%',   combines: false, sub: true  },
        jacksontest90:  { pct: 90,    label: 'JACKSONTEST90', combines: false, sub: false },
        /* FAMILY ONLY: Klaviyo mints BASKET10-XXXXXXXX per person for the cart emails (Shopify discount
           "basket10a"). There is no static BASKET10 code, so the bare word is never accepted. */
        basket10:       { pct: 10,    label: 'BASKET10',      combines: true,  sub: true,  familyOnly: true },
        /* FAMILY ONLY (2026-11-02, PV-3 returning-visitor flow Rat4Et): CREDIT15-XXXXXXXX per person, 15%, from the Shopify
           discount "back15a" (productDiscounts combine = true, applies on subscription = true, read from the Admin API).
           The key is the code's own prefix, credit15, because the family match reads the part before the dash. */
        credit15:       { pct: 15,    label: 'CREDIT15',      combines: true,  sub: true,  familyOnly: true },
        /* FAMILY ONLY (2026-11-03, owner): the spin the wheel codes, WINNER15-XXXXX, WINNER10-XXXXX and WINNER5-XXXXX. Three
           Shopify discounts ("Spin the wheel 15% / 10% / 5% (Nov 2026)"), all items, once per customer, combine with product
           discounts, subscription first delivery only (recurringCycleLimit 1), end 2026-11-30T23:59Z. The codes themselves are
           in assets/pv-winner-codes.json, which snippets/pv-spin-wheel.liquid reads after a spin. mag: true because the codes
           also take the same % off magnesium at checkout (Storefront 3 Nov: £12.75 and £33.15), so the magnesium cards show it. */
        winner15:       { pct: 15,    label: 'WINNER15',      combines: true,  sub: true,  familyOnly: true, ends: '2026-11-30T23:59:00Z', mag: true },
        winner10:       { pct: 10,    label: 'WINNER10',      combines: true,  sub: true,  familyOnly: true, ends: '2026-11-30T23:59:00Z', mag: true },
        winner5:        { pct: 5,     label: 'WINNER5',       combines: true,  sub: true,  familyOnly: true, ends: '2026-11-30T23:59:00Z', mag: true }
        /* SUBMAG20 removed 2026-11-03: the owner parked the subscriber magnesium offer and the Shopify code is deactivated (983W).
           The magOnly / starts support stays for the next such code. */
      };
      /* Single source of truth for which codes the site recognises: the on-page code-entry box below
         validates against this same map, so a code we can't preview on the cards is never accepted
         (keeps what's shown == what's charged). */
      window.pvPromoCodes = CODES;
      var els = document.querySelectorAll('[data-pv-promo-param]');
      if (!els.length) return;
      var param = els[0].getAttribute('data-pv-promo-param');
      var params = new URLSearchParams(window.location.search);
      /* The applied code can arrive two ways: the ?promo=<code> link (email/ads) OR the discount_code
         cookie that Shopify's /discount/CODE route sets. The cookie is what actually carries the discount
         into checkout (incl. the express wallets), and browsers drop the inner ?promo when /discount
         redirects (nested query), so we read the cookie as the reliable signal and let ?promo override it. */
      var codeKey = (params.get(param) || '').toLowerCase();
      if (!CODES[codeKey]) {
        var ck = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
        /* decodeURIComponent throws a URIError on a stray % that is not followed by two hex digits, and two live
           codes contain one (PVFRIEND20%, RACHEL40%ALL). Shopify normally writes the cookie percent-encoded, so
           this is rare, but unguarded it killed the WHOLE promo module for that visitor: no bar, no lit cards, no
           code entry, for the rest of the session. Fall back to the raw cookie value instead (2026-09-21, 811W). */
        if (ck) {
          var raw = ck[1];
          try { raw = decodeURIComponent(raw); } catch (e) {}
          codeKey = raw.trim().toLowerCase();
        }
      }
      var promo = CODES[codeKey];
      /* PER-PERSON CODES (owner 2026-09-14: "as long as ten percent always comes off and it shows on the
         sales cards"). Klaviyo issues each subscriber their own code from a family, e.g.
         WELCOME10-K3P2X7QM off the WELCOME10 coupon, so the exact string can never be in the map above.
         A family match fills that gap: <known code>-<token> is recognised as its family.

         IT DELIBERATELY DOES NOT RE-PRICE THE CARDS. Measured on the live store 2026-09-14: Shopify sets
         the discount_code cookie for ANY string, including codes that do not exist. WELCOME10-K3P2X7QM
         and TOTALLYFAKECODE123 both set the cookie and both left the cart at GBP 45.00 with no discount.
         So the code string is not evidence the discount is real, and the commonest case is not a typo but
         a genuine code used after its seven days: re-pricing on the family alone would print "Total to
         pay GBP 40.50" while checkout charged GBP 45, which is the exact defect that cost money in August
         (decision-log 218). Confirming validity would need a cart, and probing one silently would fire
         Added-to-Cart into Klaviyo and trigger abandoned-cart emails to people who added nothing.

         So a family code is ACKNOWLEDGED, not previewed: the bar says the code is applied at checkout,
         the cards keep their normal prices, and the real discount appears at checkout where Shopify
         calculates it. Under-promising beats mis-stating, the same rule the map above follows. */
      var familyCode = false;
      if (promo && promo.familyOnly) promo = null;
      if (!promo) {
        var fam = codeKey.match(/^([a-z0-9%!]+)-[a-z0-9]{4,16}$/);
        if (fam && CODES[fam[1]]) {
          var base = CODES[fam[1]];   /* copied, so the person's label never leaks into the shared map */
          promo = { pct: base.pct, amount: base.amount, label: codeKey.toUpperCase(), combines: base.combines, sub: base.sub, ends: base.ends };
          familyCode = true;
        }
      }
      if (!promo) return;
      /* a magnesium-only code (SUBMAG20) is shown by the magnesium cards in sections/pv-plans.liquid, never here */
      if (promo.magOnly) return;
      /* A code with an end date stops lighting the cards the moment it stops working at checkout. Shopify's own
         clock is used (data-pv-now, rendered with the page) so a wrong device clock cannot show a saving that the
         checkout will refuse, and a missing attribute falls back to the device clock rather than hiding a real
         saving. A family code inherits its family's end date through the copy above. */
      if (promo.ends) {
        var pvNowAttr = parseInt(els[0].getAttribute('data-pv-now') || '', 10);
        var pvNowMs = (pvNowAttr && isFinite(pvNowAttr)) ? pvNowAttr * 1000 : Date.now();
        var pvEndsMs = Date.parse(promo.ends);
        if (isFinite(pvEndsMs) && pvNowMs > pvEndsMs) return;
      }
      /* `lit` = the cards are showing this code's saving right now. A fixed code lights at once, exactly
         as before. A PER-PERSON code waits for Shopify's own verdict first (see THE VERDICT below). */
      var lit = false;
      function reveal() {
      /* Remember the applied code so the on-page code-entry box can hide itself (a code is already on
         the session) even after the ?promo param is stripped from the URL further down. */
      window.pvAppliedPromo = codeKey;

      /* 2026-09-17, owner, after clicking the welcome email's link himself: "it shows the discount applied box
         with the code, but the 10% is not taken off in the sales card where it shows the saving". A per-person
         code now lights the cards exactly like its family, under the person's own label. This REVERSES the
         acknowledge-only rule of 735W. What keeps it honest: the Klaviyo-made Shopify discounts behind these
         codes (welcome10a, basket10a) were one-time-only, which is why his subscription got nothing at
         checkout; they must cover subscriptions for the card maths here to match checkout (see decision log,
         same date). The residual risk recorded here that day (Shopify sets the discount_code cookie for ANY
         string, so a code past its seven days still lit the cards) is CLOSED by THE VERDICT below. */
      els.forEach(function (el) { el.hidden = false; });
      document.querySelectorAll('[data-pv-promo-label]').forEach(function (el) { el.textContent = promo.label; });
      /* The bar reads "Code X applied: <N>% off your first order at checkout". An AMOUNT code cannot be said
         that way, so rewrite the number and drop the stray % that follows it in the markup. */
      document.querySelectorAll('[data-pv-promo-pct]').forEach(function (el) {
        if (promo.pct != null) { el.textContent = promo.pct; return; }
        el.textContent = '£' + promo.amount;
        var sib = el.nextSibling;
        if (sib && sib.nodeType === 3 && sib.nodeValue.indexOf('%') === 0) {
          sib.nodeValue = sib.nodeValue.replace('%', '');
        }
      });
      /* The bar reads "...% off your first order at checkout". For a code Shopify will not apply to a
         subscription that still overstates things (there is no first subscription order to discount), so name what
         it actually covers. The phrase was "your order" until 2026-09-21 (811W); both spellings are handled so an
         older cached copy of this file cannot leave the bar unrewritten for a one-time-only code. */
      if (promo.every) {
        document.querySelectorAll('[data-pv-promo-pct]').forEach(function (el) {
          var sib = el.nextSibling;
          /* Shared wording with the emails (owner 2026-10-01, "shout about this", via HQ-0). */
          if (sib && sib.nodeType === 3) sib.nodeValue = sib.nodeValue.replace(/ off your (first )?order at checkout/, ' off. On the 3-month plan it stays on every delivery, not just the first.');
        });
      }
      if (promo.anyOrder && !promo.every) {
        document.querySelectorAll('[data-pv-promo-pct]').forEach(function (el) {
          var sib = el.nextSibling;
          if (sib && sib.nodeType === 3) sib.nodeValue = sib.nodeValue.replace('your first order', 'your order');
        });
      }
      if (promo.one === false && promo.sub === true) {   /* plan-only code (PLAN20) */
        document.querySelectorAll('[data-pv-promo-pct]').forEach(function (el) {
          var sib = el.nextSibling;
          if (sib && sib.nodeType === 3) sib.nodeValue = sib.nodeValue.replace(/ off your (first )?order at checkout/, ' off your first 3-month plan delivery at checkout');
        });
      }
      if (promo.sub !== true) {
        document.querySelectorAll('[data-pv-promo-pct]').forEach(function (el) {
          var sib = el.nextSibling;
          if (sib && sib.nodeType === 3) sib.nodeValue = sib.nodeValue.replace('your first order', 'one-time purchases').replace('your order', 'one-time purchases');
        });
      }
      }   /* end reveal() */

      /* Make the savings visibly ADD UP on every card and land the real charged total. The code is an
         EXTRA promo.pct% off the already-discounted price (verified live against the cart API: it stacks
         on the bulk/selling-plan discount, e.g. WELCOME10 10% takes £22 -> £19.80, £51 -> £45.90). So
         each receipt shows: base "% off" (from Liquid) + "Extra - code X" + a summed "Total saving",
         then the new "Total to pay". Reads the pre-code base from data-pv-base-total (the bottle stepper
         writes it fresh on every change; static cards cache it once) so a re-run never re-discounts an
         already discounted figure, and the RRP from the struck "Original price" so Total saving = RRP - final. */
      function pvMoney(n) { return '£' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2)); }
      function updatePromoPricing() {
        document.querySelectorAll('.pv-total-banner').forEach(function (banner) {
          var totalEl = banner.querySelector('.pv-receipt-total-row span:last-child');
          var promoRow = banner.querySelector('.pv-receipt-promo-row');
          if (!totalEl || !promoRow) return;
          /* THE SUBSCRIPTION GATE. Shopify will not apply a one-time-only code to a selling-plan cart,
             so this card must be left exactly as it is: rewriting it prints a total the customer is
             not charged (measured live 2026-09-06: card £36 vs checkout £45.00). The reveal loop above
             has already unhidden the promo rows for every card, so hide them again here, and say why,
             or this card just sits mysteriously dark next to two lit ones. */
          var isSub = !!banner.closest('.pv-option--subscribe');
          var cannotPreview = promo.combines === false || (isSub && promo.sub !== true) || (!isSub && promo.one === false);
          if (cannotPreview) {
            /* Two cases land here and both mean "we cannot honestly show this on THIS card":
               a non-combining code (checkout works it out a different way), or a one-time-only code
               on the subscription card (Shopify refuses it outright). Either way the reveal loop has
               already unhidden the rows, so put them back and leave every number untouched. */
            [promoRow, banner.querySelector('.pv-receipt-save-hr'), banner.querySelector('.pv-receipt-totalsave-row')]
              .forEach(function (r) { if (r) r.hidden = true; });
            if (isSub && promo.sub !== true && promo.combines !== false) {
              var note = banner.querySelector('.pv-receipt-subnote');
              if (!note) {
                note = document.createElement('div');
                note.className = 'pv-receipt-subnote';
                var anchor = banner.querySelector('.pv-receipt-perday') || banner.querySelector('.pv-receipt-total-row');
                if (anchor) anchor.insertAdjacentElement('afterend', note);
              }
              if (note) note.textContent = 'Code ' + promo.label + ' applies to one-time purchases only';
            }
            return;
          }
          var baseAttr = banner.getAttribute('data-pv-base-total');
          var base = baseAttr !== null ? parseFloat(baseAttr) : parseFloat(totalEl.textContent.replace(/[^0-9.]/g, ''));
          if (!base || isNaN(base)) return;
          if (baseAttr === null) banner.setAttribute('data-pv-base-total', base);
          var wasEl = banner.querySelector('.pv-receipt-was-row span:last-child');
          var original = wasEl ? parseFloat(wasEl.textContent.replace(/[^0-9.]/g, '')) : base;
              /* percentage codes scale with the card; amount codes take the same cash off, capped at
             that card's total. */
          var extra = (promo.pct != null)
            ? Math.round(base * promo.pct) / 100
            : Math.min(promo.amount || 0, base);
          /* NO STACKING during a timed one-bottle offer (owner via Houston 2026-10-19, "go £22"). pv-pricing.liquid marks the
             single card's receipt with data-pv-nostack="<full price>" while the offer runs. The offer's automatic discount combines
             with no code, and Shopify charges the single better one, so show exactly that: the code on the FULL price if that
             beats the offer (shown as the extra over the offer price, so the rows still add up), otherwise the offer alone,
             with one line saying the code does not combine. */
          var nsBase = parseFloat(banner.getAttribute('data-pv-nostack'));
          var nsMode = '';
          if (nsBase > base) {
            var codeFinal = (promo.pct != null) ? nsBase - Math.round(nsBase * promo.pct) / 100 : nsBase - Math.min(promo.amount || 0, nsBase);
            codeFinal = Math.round(codeFinal * 100) / 100;
            if (codeFinal >= base) {
              [promoRow, banner.querySelector('.pv-receipt-save-hr'), banner.querySelector('.pv-receipt-totalsave-row')].forEach(function (r) { if (r) r.hidden = true; });
              var nn = banner.querySelector('.pv-receipt-subnote');
              if (!nn) { nn = document.createElement('div'); nn.className = 'pv-receipt-subnote'; var an = banner.querySelector('.pv-receipt-perday') || banner.querySelector('.pv-receipt-total-row'); if (an) an.insertAdjacentElement('afterend', nn); }
              if (nn) nn.textContent = 'Code ' + promo.label + ' does not combine with this offer, so you pay ' + pvMoney(base);
              totalEl.textContent = pvMoney(base);
              return;
            }
            extra = Math.round((base - codeFinal) * 100) / 100; nsMode = 'instead';
          }
          var finalTotal = Math.round((base - extra) * 100) / 100;
          var totalSave = Math.round(((original || finalTotal) - finalTotal) * 100) / 100;
          var amtEl = banner.querySelector('[data-pv-promo-amount]');
          if (amtEl) amtEl.textContent = pvMoney(extra);
          /* On subscription cards the code discounts the FIRST order only (renewals bill the plan
             price: WELCOME10 subscription orders charge 40.50 on cycle 1 then 45 after). Say so on
             the card so the shown total is never read as the renewal price (owner, 2026-09-04). */
          /* Row reads "Extra 10% off every delivery" with "Code X" small underneath (owner 2026-10-01 via HQ-0;
             it was "Extra · code X · every delivery"). One-off cards: "Extra 10% off". Plan card with a
             first-delivery-only code: "Extra 15% off first delivery". */
          var headEl = promoRow.querySelector('[data-pv-promo-head]');
          if (headEl) {
            var what = (promo.pct != null) ? promo.pct + '% off' : pvMoney(promo.amount || 0) + ' off';
            headEl.textContent = nsMode ? ('Code gives ' + what + ' £25 instead') : ('Extra ' + what + (isSub ? (promo.every ? ' every delivery' : ' first delivery') : ''));
          }
          var tsEl = banner.querySelector('[data-pv-promo-totalsave]');
          if (tsEl) tsEl.textContent = pvMoney(totalSave);
          totalEl.textContent = pvMoney(finalTotal);
          /* "Shout about it" (owner 2026-10-01): on the plan card, a code with `every` keeps its 10% on every delivery,
             so say the renewal price plainly in a gold badge under the total. finalTotal IS the renewal price here,
             because the code's recurringCycleLimit is unlimited in Shopify. */
          if (isSub && promo.every && !banner.querySelector('.pv-every-badge')) {
            if (!document.getElementById('pv-every-badge-css')) {
              var st = document.createElement('style'); st.id = 'pv-every-badge-css';
              st.textContent = '.pv-every-badge{display:block;margin:10px 0 2px;padding:9px 12px;border-radius:10px;background:#cba866;color:#1a3a2a;font:700 15px/1.3 Figtree,-apple-system,sans-serif;text-align:center}.pv-every-badge small{display:block;font-weight:600;font-size:12.5px;opacity:.85;margin-top:2px}';
              document.head.appendChild(st);
            }
            var badge = document.createElement('div'); badge.className = 'pv-every-badge'; badge.setAttribute('role', 'note');
            badge.appendChild(document.createTextNode(pvMoney(finalTotal) + ' every 3 months, for good'));
            var sm = document.createElement('small'); sm.textContent = promo.pct + '% off every delivery, not just the first'; badge.appendChild(sm);
            var trow = banner.querySelector('.pv-receipt-total-row');
            (trow || totalEl).insertAdjacentElement('afterend', badge);
          }
          /* Drop the per-day figure to match the code price too. Since 2026-09-14 that line can sit
             OUTSIDE the receipt, as one of the ticks under the card, so look in the whole card when it
             is not in the banner. Without this fallback the card would show the full-price per-day
             figure next to a discounted total. */
          var pdCard = banner.closest('.pv-option');
          var perWrap = banner.querySelector('.pv-receipt-perday')
            || (pdCard ? pdCard.querySelector('.pv-receipt-perday') : null);
          var perNow = perWrap ? perWrap.querySelector('[data-pv-perday-now]') : null;
          if (perNow && perWrap) {
            var days = parseFloat(perWrap.getAttribute('data-pv-perday-days'));
            if (days) perNow.textContent = Math.round(finalTotal * 100 / days) + 'p';
          }
          /* Owner 2026-10-15 (preview): the big per-bottle price on the card shows what they will pay with the code, the
             normal price struck small beside it. Bottles = the card's pre-code total over its own headline price. */
          var headPrice = pdCard ? pdCard.querySelector('.pv-price-new') : null;
          if (headPrice) {
            var numNode = headPrice.firstChild;
            if (numNode && numNode.nodeType === 3) {
              if (!headPrice.hasAttribute('data-pv-head-orig')) headPrice.setAttribute('data-pv-head-orig', numNode.nodeValue);
              var headOrig = parseFloat(headPrice.getAttribute('data-pv-head-orig').replace(/[^0-9.]/g, ''));
              var nB = headOrig > 0 ? Math.max(1, Math.round(base / headOrig)) : 0;
              if (nB) {
                numNode.nodeValue = pvMoney(Math.round(finalTotal / nB * 100) / 100);
                if (!headPrice.classList.contains('pv-price-coded')) {
                  headPrice.style.fontSize = (parseFloat(getComputedStyle(headPrice).fontSize) * 0.85).toFixed(1) + 'px';
                  headPrice.classList.add('pv-price-coded');
                }
                var hw = headPrice.querySelector('.pv-head-was');
                if (!hw) { hw = document.createElement('s'); hw.className = 'pv-head-was'; headPrice.appendChild(hw); }
                /* struck figure = the full single-bottle price (owner: "should be £25"), i.e. the card's original total over its bottles */
                var fullEach = (original && original > base - 0.005) ? Math.round(original / nB * 100) / 100 : headOrig;
                hw.textContent = pvMoney(fullEach);
                /* Owner 2026-10-15 ("keep it simple and to the point, across all three"): the saving is said in ONE place,
                   the card's gold bar, as money; the closed-card pill shows the real % against £25. */
                var cardSave = Math.round((fullEach * nB - finalTotal) * 100) / 100;
                if (cardSave > 0.005) {
                  var det = pdCard.querySelector('.pv-option-details');
                  var sb = pdCard.querySelector('.pv-save-bar');
                  if (!sb && det) { sb = document.createElement('div'); sb.className = 'pv-save-bar pv-save-bar--coded'; det.insertBefore(sb, det.firstChild); }
                  if (sb) { if (!sb.hasAttribute('data-pv-save-orig')) sb.setAttribute('data-pv-save-orig', sb.textContent); sb.textContent = 'Save ' + Math.round(cardSave / (fullEach * nB) * 100) + '%'; }   /* owner: keep it as % off */
                  var pill = pdCard.querySelector('.pv-price-save');
                  if (pill) { if (!pill.hasAttribute('data-pv-save-orig')) pill.setAttribute('data-pv-save-orig', pill.textContent);
                    pill.textContent = 'Save ' + Math.round(cardSave / (fullEach * nB) * 100) + '%'; }
                }
              }
            }
          }
        });
      }
      /* Always called: it now gates itself per card. It used to be skipped entirely for a
         non-combining code, which left the promo rows revealed by the loop above still showing their
         markup defaults, i.e. "Extra - code X £0 / Total saving £0". */
      var codeEntryWrap = document.querySelector('[data-pv-code-entry]');
      function light() {
        lit = true;
        reveal();
        updatePromoPricing();
        pvSyncBuyNowSubline();
        if (codeEntryWrap) codeEntryWrap.hidden = true;   /* a code is on the session: no empty box under the cards */
      }
      /* Put every card back exactly as Liquid rendered it. Only ever needed when a verdict arrives AFTER the
         cards were lit on the patience timer below, which takes a slow network and an ended code together. */
      function unlight() {
        lit = false;
        window.pvAppliedPromo = null;
        els.forEach(function (el) { el.hidden = true; });
        document.querySelectorAll('.pv-total-banner').forEach(function (banner) {
          var totalEl = banner.querySelector('.pv-receipt-total-row span:last-child');
          var baseAttr = banner.getAttribute('data-pv-base-total');
          var base = baseAttr !== null ? parseFloat(baseAttr) : NaN;
          if (totalEl && base && !isNaN(base)) {
            totalEl.textContent = pvMoney(base);
            var pdCard = banner.closest('.pv-option');
            var perWrap = banner.querySelector('.pv-receipt-perday') || (pdCard ? pdCard.querySelector('.pv-receipt-perday') : null);
            var perNow = perWrap ? perWrap.querySelector('[data-pv-perday-now]') : null;
            var days = perWrap ? parseFloat(perWrap.getAttribute('data-pv-perday-days')) : 0;
            if (perNow && days) perNow.textContent = Math.round(base * 100 / days) + 'p';
          }
          var note = banner.querySelector('.pv-receipt-subnote');
          if (note) note.parentNode.removeChild(note);
          var hp = banner.closest('.pv-option') ? banner.closest('.pv-option').querySelector('.pv-price-new[data-pv-head-orig]') : null;
          if (hp) { if (hp.firstChild && hp.firstChild.nodeType === 3) hp.firstChild.nodeValue = hp.getAttribute('data-pv-head-orig'); hp.classList.remove('pv-price-coded'); hp.style.fontSize = '';
            var hw2 = hp.querySelector('.pv-head-was'); if (hw2) hw2.parentNode.removeChild(hw2); }
          var oc = banner.closest('.pv-option');
          if (oc) oc.querySelectorAll('[data-pv-save-orig]').forEach(function (el) {
            if (el.classList.contains('pv-save-bar--coded')) { el.parentNode.removeChild(el); return; }
            el.textContent = el.getAttribute('data-pv-save-orig'); el.removeAttribute('data-pv-save-orig'); });
        });
        pvSyncBuyNowSubline();
        if (codeEntryWrap) codeEntryWrap.hidden = false;
      }
      /* A code Shopify refuses: no saving anywhere, and one plain line so the customer who clicked "10% off"
         in an email is not left wondering. "No longer valid" is true of all three causes (the batch ended,
         the code was already used, it never existed). The code line under the cards stays available. */
      function showRefused() {
        var bar = document.querySelector('#pricing .pv-promo-bar') || document.querySelector('.pv-promo-bar');
        if (!bar) return;
        bar.classList.add('pv-promo-bar--refused');
        bar.textContent = '';
        var span = document.createElement('span');
        span.appendChild(document.createTextNode('Code '));
        var strong = document.createElement('strong'); strong.textContent = promo.label; span.appendChild(strong);
        span.appendChild(document.createTextNode(' is no longer valid and has not been applied'));
        bar.appendChild(span);
        bar.hidden = false;
      }
      document.addEventListener('pv:price-updated', function () { if (!lit) return; updatePromoPricing(); pvSyncBuyNowSubline(); });

      /* THE VERDICT (owner 2026-09-17, relayed by Email: "dont want website showing old personal codes").
         snippets/pv-code-check.liquid asks Shopify, from the top of <head>, whether THIS per-person code
         applies to a one-bottle cart and to a plan cart, and leaves a promise on window.pvCodeCheck.
           both refused          -> nothing is lit, one plain line says the code is no longer valid
           plan refused only     -> the plan card stays dark with the usual "one-time purchases only" note
                                    (a new Klaviyo batch in the minutes before the guard widens it)
           could not ask (null)  -> the family's defaults, i.e. exactly what happened before this existed.
                                    Unknown must never hide a saving a customer is entitled to.
         The answer normally beats this script to the page, so a live code lights with no wait. If it has
         not arrived within a second the cards light on the family's defaults, and the late answer still
         corrects them. Fixed codes never come through here. */
      if (!familyCode || !window.pvCodeCheck || typeof window.pvCodeCheck.then !== 'function') {
        light();
      } else {
        var patience = setTimeout(function () { if (!lit) light(); }, 1000);
        window.pvCodeCheck.then(function (v) {
          clearTimeout(patience);
          var known = v && String(v.code || '').toLowerCase() === codeKey;
          if (!known || (v.one === null && v.plan === null)) { if (!lit) light(); return; }
          if (v.one === false && v.plan === false) { if (lit) unlight(); showRefused(); return; }
          var changed = false;
          if (v.plan === false && promo.sub === true) { promo.sub = false; changed = true; }
          if (v.one === false && promo.one !== false) { promo.one = false; changed = true; }
          if (lit && changed) unlight();
          if (!lit) light();
        }, function () { clearTimeout(patience); if (!lit) light(); });
      }

      /* The "10% discount applied" toast was removed 2026-07-22 (owner: not needed). A subscriber has already
         seen the interstitial say it and lands on cards that are already lit; the inline .pv-promo-bar still
         confirms the code. Markup deleted from sections/pv-pricing.liquid in the same change. */

      params.delete(param);
      var qs = params.toString();
      var cleanUrl = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
      window.history.replaceState(null, '', cleanUrl);

      /* Owner 2026-07-29: "when the customer enters email for 10% discount it does the transition, great,
         but then it re-opens them back to the top of the page. I want it to scroll them back down to the
         sales cards."
         Claiming the code routes through Shopify's /discount/CODE?redirect= so the discount attaches to the
         session, and that is a genuine navigation, so the browser lands at the top. Nothing was broken, the
         page just reloaded. Reuse the SAME framing the cards already use on tap (pvFrameCta), so the
         customer arrives at the exact position a card tap gives them, wallet button included, rather than
         at some arbitrary anchor.
         Called twice for the same reason the tap path does it: the receipt rewrites and the accordion runs
         a 350ms max-height transition, so a single early pass measures a card that is still growing.
         LP-only, matching the rest of the LP checkout framing; the funnel's flow is unchanged. */
      if (PV_LP) {
        var promoSection = document.querySelector('.pv-pricing-section') || document.getElementById('pricing');
        if (promoSection) {
          setTimeout(function () { pvFrameCta(promoSection); }, 450);
          setTimeout(function () { pvFrameCta(promoSection); }, 900);
        }
      }
    })();

    // -- Faint on-page discount-code entry (under the wallet buttons). The express wallets
    //    (Shop Pay / Apple Pay / Google Pay) have no code field of their own, so a customer holding
    //    a code who did NOT arrive via a /discount/ link can apply it here. On apply we route through
    //    Shopify's /discount/CODE?redirect= cookie, which attaches the discount to the session for
    //    EVERY checkout path incl. the wallets (decision-log 150/182), landing back on the funnel with
    //    ?promo=<code> so the promo confirmation UI + receipt light up. Auto-hidden when a code is
    //    already applied, so we never show an empty box to someone who's already sorted.
    (function () {
      /* Back from the /discount/ redirect after applying a code in the box: return the customer to the cards
         they were looking at (on a landing page the cards are far down the page). Shopify percent-encodes a
         #hash inside ?redirect= (tested 2026-09-17: /pages/m45%23pricing, a 404), so the position rides in
         sessionStorage. Runs before the early return below, which hides the box once a code is on the session. */
      try {
        if (window.sessionStorage.getItem('pv_code_return') === '1') {
          window.sessionStorage.removeItem('pv_code_return');
          /* Aim at the cards themselves (the section's heading sits above them), leave room for the fixed
             ticker/header, and re-aim after load and once more shortly after: on a long landing page the
             content above keeps settling (lazy photos, videos), which moved the first aim by ~350px. A
             customer who has started scrolling by then is left alone. */
          var backTo = document.querySelector('#pricing .pv-pricing-stack') || document.getElementById('pricing');
          if (backTo) {
            var touched = false;
            ['wheel', 'touchstart', 'keydown'].forEach(function (ev) { window.addEventListener(ev, function () { touched = true; }, { passive: true, once: true }); });
            var jump = function () {
              if (touched) return;
              var y = backTo.getBoundingClientRect().top + (window.pageYOffset || 0) - 96;
              try { window.scrollTo({ top: Math.max(0, y), left: 0, behavior: 'instant' }); } catch (e) { window.scrollTo(0, Math.max(0, y)); }
            };
            jump();
            window.addEventListener('load', function () { setTimeout(jump, 60); setTimeout(jump, 900); });
          }
        }
      } catch (e) {}
      var wrap = document.querySelector('[data-pv-code-entry]');
      if (!wrap) return;
      // A code already applied (arrived via a /discount or ?promo link)? Hide the box entirely so no one
      // re-enters a code that's already on the session. pvAppliedPromo is set by the promo module above,
      // which runs first and strips ?promo from the URL, so we can't rely on the param alone here.
      /* It used to return here, before binding anything. Since 2026-09-17 a per-person code that Shopify
         refuses un-hides this line after the fact, so the controls are always wired and only the hiding
         is conditional. */
      if (window.pvAppliedPromo || (new URLSearchParams(window.location.search)).get('promo')) { wrap.hidden = true; }
      var toggle = wrap.querySelector('[data-pv-code-toggle]');
      var box = wrap.querySelector('#pv-code-box');
      var input = wrap.querySelector('[data-pv-code-input]');
      var applyBtn = wrap.querySelector('[data-pv-code-apply]');
      var msg = wrap.querySelector('[data-pv-code-msg]');
      var subBtn = wrap.querySelector('[data-pv-code-sub]');
      if (!toggle || !box || !input || !applyBtn) return;
      /* The invalid-code nudge offers "Subscribe to get 10% off" -> open the email-capture popup (which
         hands out WELCOME10 and auto-applies it), turning a dead-end code into a signup. */
      if (subBtn) subBtn.addEventListener('click', function () {
        if (typeof window.pvOpenEmailPopup === 'function') window.pvOpenEmailPopup();
      });
      toggle.addEventListener('click', function () {
        var willOpen = box.hidden;
        box.hidden = !willOpen;
        toggle.setAttribute('aria-expanded', String(willOpen));
        if (willOpen) input.focus();
      });
      function applyCode() {
        var code = (input.value || '').trim().toUpperCase();
        if (!code) { input.focus(); return; }
        /* Only accept codes the site actually recognises (same map that drives the card preview), so a
           code we can't reflect on the cards is never applied -> what's shown always matches what's charged.
           Valid codes route through /discount/CODE?redirect=...?promo=code, i.e. the exact same path as the
           subscriber-signup auto-apply, so the cards + receipt update identically and it carries into the
           express wallets. */
        var accepted = window.pvPromoCodes || {};
        var key = code.toLowerCase();
        var promo = accepted[key], family = false;
        if (promo && promo.familyOnly) promo = null;
        /* Per-person codes (WELCOME10-K3P2X7QM): the same family rule the arrival module uses. */
        if (!promo) { var fam = key.match(/^([a-z0-9%!]+)-[a-z0-9]{4,16}$/); if (fam && accepted[fam[1]]) { promo = accepted[fam[1]]; family = true; } }
        if (!promo) {
          if (msg) msg.hidden = false;   /* message + "Subscribe for 10%" nudge is static markup */
          input.focus(); input.select();
          return;
        }
        if (msg) msg.hidden = true;
        applyBtn.disabled = true; applyBtn.textContent = 'Applying…';
        /* Set Shopify's discount cookie (carries the code into every checkout path incl. the express
           wallets) and land back on the funnel. No inner ?promo needed: the promo module reads the
           discount_code cookie on arrival and lights up the cards, avoiding the browser dropping a
           nested query through the /discount redirect. */
        try { window.sessionStorage.setItem('pv_code_return', '1'); } catch (e) {}
        /* Back to THIS page (funnel or landing page), not always the funnel. */
        var target = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname);
        /* Same interstitial as the pop-up (owner 2026-09-17: "it will do the same transition"), showing THIS
           code's value; a per-person code shows its family's. */
        if (typeof window.pvPlayInterstitial === 'function' && document.getElementById('pv-di')) {
          var pctEl = document.querySelector('#pv-di .pv-di-pct');
          if (pctEl) pctEl.textContent = promo.pct ? (promo.pct + '%') : ('\u00a3' + promo.amount);
          window.pvPlayInterstitial(target);
        } else {
          window.location.href = target;
        }
      }
      applyBtn.addEventListener('click', applyCode);
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); applyCode(); } });
      input.addEventListener('input', function () { if (msg && !msg.hidden) msg.hidden = true; });
    })();

    // -- Sales page, mobile only: keep the menu bar hidden while the customer is in the pricing
    // cards area (maximum space for the cards), and let it slide back in as soon as they scroll
    // UP past the cards (stack top crosses the middle of the screen). Overrides the theme's own
    // scroll-up-reveals-the-menu behaviour just for this zone, via a class on <html>.
    // NOTE: the headless preview keeps the menu pinned, so this can only be confirmed on a device.
    (function () {
      var pricing = document.getElementById('pricing');
      var stack = document.querySelector('#pricing .pv-pricing-stack');
      if (!pricing || !stack) return;
      var hidden = false;
      function setMenu(h) { if (h === hidden) return; hidden = h; document.documentElement.classList.toggle('pv-cards-hide-menu', h); }
      function update() {
        if ((window.innerWidth || document.documentElement.clientWidth) > 640) { setMenu(false); return; }
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var sr = stack.getBoundingClientRect();
        // Once the cards have scrolled fully above the top of the screen, the customer is on the
        // clinical studies block (or beyond): release the menu to the theme's NATIVE scroll
        // behaviour, so scrolling UP there brings the top menu back. (The gold + bottom bars do
        // their own after-studies reveal; the menu is intentionally NOT force-tied to them.)
        if (sr.bottom <= 0) { setMenu(false); return; }
        // Cards still in view: hide once they reach the upper half; show again up in the hero. This
        // is the "all of it disappears when it gets to the sales cards" zone -- left untouched.
        if (!hidden && sr.top < vh * 0.5) setMenu(true);
        else if (hidden && sr.top > vh * 0.6) setMenu(false);
      }
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    })();

    // One-time bulk: a 1-12 stepper whose discount CLIMBS as you add bottles (each bottle
    // knocks £1 off every bottle, up to 40% off / £15 per bottle). Shows the per-bottle price
    // so it compares directly with the subscription /mo cards. The +/- click bubbles to the
    // card's own selection handler, which keeps the big Buy Now bar in sync with the quantity.
    document.querySelectorAll('[data-pv-qty-select]').forEach(function (wrap) {
      var card = wrap.closest('[data-pv-option]');
      var base = wrap.getAttribute('data-pv-base') || '/cart';
      var SINGLE = 25;
      // One-time bulk ladder (owner-set 2026-07-07, ROUND prices): 1=£22, 2=£20, 3=£17 (held for 3-5),
      // 6=£15 (max, held for 6-12), off the £25 RRP -> 12% / 20% / 32% / 40% / 40%. Per-bottle prices MUST
      // match the live Shopify automatic discounts (minQty 1>=12%, 2>=20%, 3>=32%, 6>=40%) or the card lies.
      var STEPS = [1, 2, 3, 6, 12];
      var PER = { 1:22, 2:20, 3:17, 6:15, 12:15 };
      var idx = 0;
      var countEl = wrap.querySelector('[data-pv-qty-count]');
      var decBtn = wrap.querySelector('[data-pv-qty-dec]');
      var incBtn = wrap.querySelector('[data-pv-qty-inc]');
      var bulk = card ? card.querySelector('[data-pv-bulk]') : null;
      var fill = card ? card.querySelector('[data-pv-bulk-fill]') : null;
      var msg  = card ? card.querySelector('[data-pv-bulk-msg]') : null;
      var priceEl = card ? card.querySelector('.pv-price-new') : null;
      var perEl = card ? card.querySelector('.pv-price-per') : null;
      var wasEl = card ? card.querySelector('[data-pv-qty-was]') : null;
      var saveEl = card ? card.querySelector('[data-pv-qty-save]') : null;
      var totalBannerPriceEl = card ? card.querySelector('[data-pv-total-banner-price]') : null;
      var qtyPerEl = card ? card.querySelector('[data-pv-qty-per]') : null;
      var recQtyEl = card ? card.querySelector('[data-pv-receipt-qty]') : null;
      var recSupplyEl = card ? card.querySelector('[data-pv-receipt-supply]') : null;
      var recWasRowEl = card ? card.querySelector('[data-pv-receipt-was]') : null;
      var recWasValEl = card ? card.querySelector('[data-pv-receipt-was-val]') : null;
      var recDiscRowEl = card ? card.querySelector('[data-pv-receipt-disc]') : null;
      var recDiscValEl = card ? card.querySelector('[data-pv-receipt-disc-val]') : null;
      var recSaveRowEl = card ? card.querySelector('[data-pv-receipt-save-row]') : null;
      var recSaveValEl = card ? card.querySelector('[data-pv-receipt-save-val]') : null;
      var recHrEl = card ? card.querySelector('[data-pv-receipt-hr]') : null;
      function money(n) { return '£' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2)); }
      function pctOf(q) { return Math.round((SINGLE - PER[q]) / SINGLE * 100); }
      function apply() {
        var cur = STEPS[idx], per = PER[cur], p = pctOf(cur), total = per * cur, save = (SINGLE - per) * cur, perDay = Math.round(per / 30 * 100);
        if (countEl) countEl.textContent = cur;
        if (decBtn) decBtn.disabled = idx <= 0;
        if (incBtn) incBtn.disabled = idx >= STEPS.length - 1;
        if (priceEl) priceEl.innerHTML = money(per) + '<span class="pv-price-permo">/bottle</span>';
        if (wasEl) { wasEl.innerHTML = p > 0 ? ('was <s>' + money(SINGLE) + '</s>') : ''; wasEl.style.display = p > 0 ? '' : 'none'; }
        if (saveEl) { saveEl.textContent = p > 0 ? ('Save ' + p + '%') : ''; saveEl.style.display = p > 0 ? '' : 'none'; }
        if (qtyPerEl) qtyPerEl.textContent = (cur === 1 ? '1 month’s supply' : cur + ' months’ supply') + ' · ' + perDay + 'p a day';
        var hasDisc = p > 0;
        if (recQtyEl) recQtyEl.textContent = cur;
        if (recSupplyEl) recSupplyEl.textContent = cur === 1 ? '1 month\'s supply' : (cur + ' months\' supply');
        if (recWasRowEl) recWasRowEl.style.display = hasDisc ? '' : 'none';
        if (recWasValEl) recWasValEl.textContent = money(SINGLE * cur);
        if (recDiscRowEl) recDiscRowEl.style.display = hasDisc ? '' : 'none';
        if (recDiscValEl) recDiscValEl.textContent = '-' + p + '%';
        if (recSaveRowEl) recSaveRowEl.style.display = hasDisc ? '' : 'none';
        if (recSaveValEl) recSaveValEl.textContent = money(save);
        if (recHrEl) recHrEl.style.display = hasDisc ? '' : 'none';
        if (totalBannerPriceEl) totalBannerPriceEl.textContent = money(total);
        if (fill) fill.style.width = Math.round(p / 40 * 100) + '%';
        if (bulk) { bulk.classList.toggle('pv-bulk-on', p > 0); bulk.classList.toggle('pv-bulk-max', idx >= STEPS.length - 1); }
        if (msg) {
          if (idx === 0) {
            msg.innerHTML = 'Buy more, save more. Up to <strong>40% off</strong>.';
          } else if (idx >= STEPS.length - 1) {
            msg.innerHTML = '<strong>40% off</strong> unlocked, the best price at <strong>£15/bottle</strong>.';
          } else {
            var nq = STEPS[idx + 1];
            msg.innerHTML = '<strong>' + p + '% off</strong> &middot; ' + nq + ' bottles for <strong>' + pctOf(nq) + '% off</strong>';
          }
        }
        if (card) {
          card.setAttribute('data-pv-href', base + ':' + cur);
          card.setAttribute('data-pv-plan', cur === 1 ? 'One-Time Purchase' : ('One-Time, ' + cur + ' bottles'));
          card.querySelectorAll('[data-pv-qty-set]').forEach(function (b) { b.classList.toggle('pv-buy3-on', parseInt(b.getAttribute('data-pv-qty-set'), 10) === cur); });
        }
        /* Publish the fresh PRE-code total so the WELCOME10 promo module (if active) re-applies its
           extra 10% off the new figure, never a stale/already-discounted one. */
        var promoBanner = card ? card.querySelector('.pv-total-banner') : null;
        if (promoBanner) promoBanner.setAttribute('data-pv-base-total', total);
        document.dispatchEvent(new CustomEvent('pv:price-updated'));
      }
      function step(d) { var n = Math.min(STEPS.length - 1, Math.max(0, idx + d)); if (n === idx) return; idx = n; apply(); }
      function setQty(n) { var i = STEPS.indexOf(n); if (i < 0) return; idx = i; apply(); }
      if (decBtn) decBtn.addEventListener('click', function () { step(-1); });
      if (incBtn) incBtn.addEventListener('click', function () { step(1); });
      if (card) card.querySelectorAll('[data-pv-qty-set]').forEach(function (b) { b.addEventListener('click', function () { setQty(parseInt(b.getAttribute('data-pv-qty-set'), 10)); }); });
      apply();
    });

    // -- FAQ accordion ------------------------------------------
    document.querySelectorAll('[data-pv-faq]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.pv-faq-item');
        var open = item.classList.toggle('pv-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.querySelector('.pv-faq-icon').textContent = open ? '\u2212' : '+';
      });
    });

    // -- Science tabs -------------------------------------------
    document.querySelectorAll('[data-pv-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-pv-tab');
        document.querySelectorAll('.pv-science-tab').forEach(function (t) {
          t.classList.remove('pv-tab-active');
          t.setAttribute('aria-selected', 'false');
        });
        document.querySelectorAll('.pv-science-panel').forEach(function (p) { p.classList.remove('pv-panel-active'); });
        tab.classList.add('pv-tab-active');
        tab.setAttribute('aria-selected', 'true');
        var panel = document.getElementById('pv-tab-' + key);
        if (panel) panel.classList.add('pv-panel-active');
      });
    });

    // -- Carousel arrows + dots ---------------------------------
    document.querySelectorAll('[data-pv-rail]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var name = btn.getAttribute('data-pv-rail');
        var dir = parseInt(btn.getAttribute('data-pv-dir'), 10) || 1;
        var rail = document.querySelector('[data-pv-rail-el="' + name + '"]');
        if (!rail) return;
        var card = rail.querySelector('.pv-video-card, .pv-review');
        var step = card ? card.getBoundingClientRect().width + 12 : 280;
        rail.scrollBy({ left: dir * step, behavior: 'smooth' });
      });
    });

    // dot sync for video rail
    var videoRail = document.querySelector('[data-pv-rail-el="videos"]');
    var dots = document.querySelectorAll('[data-pv-dot]');
    if (videoRail && dots.length) {
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var idx = parseInt(dot.getAttribute('data-pv-dot'), 10);
          var card = videoRail.querySelector('.pv-video-card');
          if (!card) return;
          videoRail.scrollTo({ left: idx * (card.getBoundingClientRect().width + 12), behavior: 'smooth' });
        });
      });
      videoRail.addEventListener('scroll', function () {
        var card = videoRail.querySelector('.pv-video-card');
        if (!card) return;
        var idx = Math.round(videoRail.scrollLeft / (card.getBoundingClientRect().width + 12));
        // the rail shows several cards at once, so the end is reached before idx hits the last card:
        // snap to the final dot once scrolled fully right.
        if (videoRail.scrollLeft + videoRail.clientWidth >= videoRail.scrollWidth - 2) idx = dots.length - 1;
        idx = Math.max(0, Math.min(idx, dots.length - 1));
        dots.forEach(function (d, i) { d.classList.toggle('pv-dot-active', i === idx); });
      }, { passive: true });
    }

    // -- Videos: gentle auto-scroll like the reviews rail (self-contained), starts shortly after entering view --
    (function () {
      var rail = document.querySelector('[data-pv-rail-el="videos"]');
      if (!rail || rail.dataset.pvVAuto || !('IntersectionObserver' in window)) return;
      rail.dataset.pvVAuto = '1';
      var SPEED = 0.5, dir = 1, raf = null, started = false, hovering = false, pauseUntil = 0, resumeT = null;
      var wrap = rail.closest('.pv-carousel-wrap') || rail;
      function tick(ts) {
        raf = requestAnimationFrame(tick);
        if (hovering || window.__pvPageScrolling) return;
        var max = rail.scrollWidth - rail.clientWidth;
        if (max <= 1) return;
        if (pauseUntil && ts < pauseUntil) return;
        pauseUntil = 0;
        rail.scrollLeft += SPEED * dir;
        if (dir > 0 && rail.scrollLeft >= max - 1) { dir = -1; pauseUntil = ts + 1300; }
        else if (dir < 0 && rail.scrollLeft <= 1) { dir = 1; pauseUntil = ts + 1300; }
      }
      function begin() { if (started) return; started = true; rail.style.scrollSnapType = 'none'; raf = requestAnimationFrame(tick); }
      wrap.addEventListener('mouseenter', function () { hovering = true; });
      wrap.addEventListener('mouseleave', function () { hovering = false; });
      wrap.addEventListener('touchstart', function () { hovering = true; if (resumeT) clearTimeout(resumeT); }, { passive: true });
      wrap.addEventListener('touchend', function () { resumeT = setTimeout(function () { hovering = false; }, 2500); }, { passive: true });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting && !started) { setTimeout(begin, 1500); } });
      }, { threshold: 0.25 });
      io.observe(rail);
    })();

    // -- Reviews rail: slow auto-scroll, starts ~3s after it enters view --
    (function () {
      var rail = document.querySelector('[data-pv-rail-el="reviews"]');
      if (!rail || rail.dataset.pvAuto || !('IntersectionObserver' in window)) return;
      var SPEED = 0.5, dir = 1, raf = null, started = false, hardStop = false, hovering = false, pauseUntil = 0;
      function tick(ts) {
        if (hardStop) return;
        raf = requestAnimationFrame(tick);
        if (hovering || window.__pvPageScrolling) return;
        var max = rail.scrollWidth - rail.clientWidth;
        if (max <= 1) return;
        if (pauseUntil && ts < pauseUntil) return;
        pauseUntil = 0;
        rail.scrollLeft += SPEED * dir;
        if (dir > 0 && rail.scrollLeft >= max - 1) { dir = -1; pauseUntil = ts + 1200; }
        else if (dir < 0 && rail.scrollLeft <= 1) { dir = 1; pauseUntil = ts + 1200; }
      }
      function begin() { if (started || hardStop) return; started = true; rail.style.scrollSnapType = 'none'; raf = requestAnimationFrame(tick); }
      function stopHard() { if (hardStop) return; hardStop = true; if (raf) cancelAnimationFrame(raf); raf = null; rail.style.scrollSnapType = ''; }
      rail.addEventListener('mouseenter', function () { hovering = true; });
      rail.addEventListener('mouseleave', function () { hovering = false; });
      ['pointerdown', 'touchstart', 'keydown'].forEach(function (ev) { rail.addEventListener(ev, stopHard, { passive: true }); });
      document.querySelectorAll('[data-pv-rail="reviews"]').forEach(function (b) { b.addEventListener('click', stopHard); });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && !started && !hardStop) {
            setTimeout(function () { if (!hardStop && !started) begin(); }, 3000);
          }
        });
      }, { threshold: 0.4 });
      io.observe(rail);
    })();

    // -- Science tabs: very slowly drift to the end once, hinting there are more (mobile only, where they overflow) --
    (function () {
      var rail = document.querySelector('.pv-science-tabs');
      if (!rail || rail.dataset.pvTabAuto || !('IntersectionObserver' in window)) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      rail.dataset.pvTabAuto = '1';
      var SPEED = 0.35, raf = null, started = false, hardStop = false, hovering = false;
      function tick() {
        if (hardStop) return;
        var max = rail.scrollWidth - rail.clientWidth;
        if (max <= 1) return;
        if (!hovering && !window.__pvPageScrolling) {
          rail.scrollLeft += SPEED;
          if (rail.scrollLeft >= max - 1) return; // reached the end: stop
        }
        raf = requestAnimationFrame(tick);
      }
      function begin() {
        if (started || hardStop) return;
        if ((rail.scrollWidth - rail.clientWidth) <= 1) return; // no overflow (desktop): nothing to reveal
        started = true; raf = requestAnimationFrame(tick);
      }
      function stopHard() { hardStop = true; if (raf) cancelAnimationFrame(raf); }
      rail.addEventListener('mouseenter', function () { hovering = true; });
      rail.addEventListener('mouseleave', function () { hovering = false; });
      ['pointerdown', 'touchstart', 'keydown', 'wheel'].forEach(function (ev) { rail.addEventListener(ev, stopHard, { passive: true }); });
      document.querySelectorAll('[data-pv-tab]').forEach(function (b) { b.addEventListener('click', stopHard); });
      var tio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting && !started && !hardStop) { setTimeout(function () { if (!hardStop && !started) begin(); }, 1200); } });
      }, { threshold: 0.5 });
      tio.observe(rail);
    })();

    // -- Portrait video testimonial modal (swipeable, auto-advance) --
    (function () {
      var modal = document.getElementById('pv-vid-modal');
      if (!modal) return;
      var viewport = modal.querySelector('.pv-vmodal-viewport');
      var cards = Array.prototype.slice.call(document.querySelectorAll('.pv-video-card'));
      var data = cards.map(function (card) {
        var thumb = card.querySelector('.pv-video-thumb');
        var t = card.querySelector('.pv-video-title');
        var nm = card.querySelector('.pv-video-name');
        return {
          id: thumb ? (thumb.getAttribute('data-pv-yt') || '') : '',
          title: t ? t.textContent : '',
          name: nm ? nm.textContent : ''
        };
      });
      var n = data.length;
      if (!n) return;

      var current = 0, animating = false, player = null, activeSlide = null;
      var apiRequested = false, pendingApi = [];

      function loadApi(cb) {
        if (window.YT && window.YT.Player) { cb(); return; }
        pendingApi.push(cb);
        if (apiRequested) return;
        apiRequested = true;
        var prev = window.onYouTubeIframeAPIReady;
        window.onYouTubeIframeAPIReady = function () {
          if (typeof prev === 'function') { try { prev(); } catch (e) {} }
          var list = pendingApi.slice(); pendingApi = [];
          list.forEach(function (f) { f(); });
        };
        var s = document.createElement('script');
        s.src = 'https://www.youtube.com/iframe_api';
        document.head.appendChild(s);
      }

      function buildSlide(i) {
        var slide = document.createElement('div');
        slide.className = 'pv-vslide';
        slide._index = i;
        var frame = document.createElement('div');
        frame.className = 'pv-vslide-frame';
        if (data[i].id) {
          var holder = document.createElement('div');
          holder.className = 'pv-vslide-player';
          frame.appendChild(holder);
          slide._holder = holder;
        } else {
          var ph = document.createElement('div');
          ph.className = 'pv-vslide-placeholder';
          ph.textContent = 'Video coming soon';
          frame.appendChild(ph);
        }
        var meta = document.createElement('div');
        meta.className = 'pv-vslide-meta';
        var stars = document.createElement('div'); stars.className = 'pv-vslide-stars'; stars.textContent = '\u2605\u2605\u2605\u2605\u2605';
        var title = document.createElement('div'); title.className = 'pv-vslide-title'; title.textContent = data[i].title;
        var name = document.createElement('div'); name.className = 'pv-vslide-name'; name.textContent = data[i].name;
        meta.appendChild(stars); meta.appendChild(title); meta.appendChild(name);
        slide.appendChild(frame); slide.appendChild(meta);
        return slide;
      }

      function destroyPlayer() {
        if (player && player.destroy) { try { player.destroy(); } catch (e) {} }
        player = null;
      }

      function mountPlayer(slide) {
        if (!slide || !slide._holder || !data[slide._index].id) return;
        loadApi(function () {
          if (!slide._holder || !slide.isConnected) return;
          destroyPlayer();
          player = new YT.Player(slide._holder, {
            videoId: data[slide._index].id,
            playerVars: { autoplay: 1, modestbranding: 1, rel: 0, playsinline: 1, fs: 0, iv_load_policy: 3, controls: 1 },
            events: {
              onStateChange: function (e) { if (e.data === YT.PlayerState.ENDED) go(1); }
            }
          });
        });
      }

      function showFirst(i) {
        viewport.innerHTML = '';
        destroyPlayer();
        current = i;
        activeSlide = buildSlide(i);
        viewport.appendChild(activeSlide);
        mountPlayer(activeSlide);
      }

      function go(dir) {
        if (animating || n < 2) return;
        var target = (current + dir + n) % n;
        animating = true;
        destroyPlayer();
        var incoming = buildSlide(target);
        incoming.style.transform = 'translateX(' + (dir > 0 ? '100%' : '-100%') + ')';
        viewport.appendChild(incoming);
        void incoming.offsetWidth; // reflow
        activeSlide.classList.add('pv-vanim');
        incoming.classList.add('pv-vanim');
        activeSlide.style.transform = 'translateX(' + (dir > 0 ? '-100%' : '100%') + ')';
        incoming.style.transform = 'translateX(0)';
        var old = activeSlide, doneFlag = false;
        function finish() {
          if (doneFlag) return; doneFlag = true;
          if (old && old.parentNode) old.parentNode.removeChild(old);
          activeSlide = incoming;
          activeSlide.classList.remove('pv-vanim');
          current = target;
          animating = false;
          mountPlayer(activeSlide);
        }
        incoming.addEventListener('transitionend', finish, { once: true });
        setTimeout(finish, 500);
      }

      function open(i) {
        showFirst(i);
        modal.classList.add('pv-open');
        document.body.style.overflow = 'hidden';
      }
      function close() {
        destroyPlayer();
        modal.classList.remove('pv-open');
        viewport.innerHTML = '';
        activeSlide = null;
        document.body.style.overflow = '';
      }

      cards.forEach(function (card, i) {
        var thumb = card.querySelector('.pv-video-thumb');
        if (!thumb) return;
        thumb.addEventListener('click', function () { open(i); });
        thumb.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(i); } });
      });
      modal.querySelectorAll('[data-pv-vclose]').forEach(function (el) { el.addEventListener('click', close); });
      modal.querySelectorAll('[data-pv-vnav]').forEach(function (el) {
        el.addEventListener('click', function () { go(parseInt(el.getAttribute('data-pv-vnav'), 10) || 1); });
      });
      document.addEventListener('keydown', function (e) {
        if (!modal.classList.contains('pv-open')) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowRight') go(1);
        else if (e.key === 'ArrowLeft') go(-1);
      });

      // swipe
      var sx = 0, sy = 0, swiping = false;
      viewport.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; swiping = true;
      }, { passive: true });
      viewport.addEventListener('touchend', function (e) {
        if (!swiping) return; swiping = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - sx, dy = t.clientY - sy;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
      }, { passive: true });
    })();

    // -- Supplement facts popup ---------------------------------
    var factsModal = document.getElementById('pv-facts-modal');
    if (factsModal) {
      function openFacts() {
        factsModal.classList.add('pv-open');
        document.body.style.overflow = 'hidden';
        var c = factsModal.querySelector('.pv-modal-close');
        if (c) c.focus();
      }
      function closeFacts() {
        factsModal.classList.remove('pv-open');
        document.body.style.overflow = '';
      }
      document.querySelectorAll('[data-pv-facts-open]').forEach(function (b) { b.addEventListener('click', openFacts); });
      factsModal.querySelectorAll('[data-pv-facts-close]').forEach(function (b) { b.addEventListener('click', closeFacts); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeFacts(); });
    }

    // -- Studies / research popup -------------------------------
    var studiesModal = document.getElementById('pv-studies-modal');
    if (studiesModal) {
      function openStudies() { studiesModal.classList.add('pv-open'); document.body.style.overflow = 'hidden'; var c = studiesModal.querySelector('.pv-modal-close'); if (c) c.focus(); }
      function closeStudies() { studiesModal.classList.remove('pv-open'); document.body.style.overflow = ''; }
      document.querySelectorAll('[data-pv-studies-open]').forEach(function (b) { b.addEventListener('click', openStudies); });
      studiesModal.querySelectorAll('[data-pv-studies-close]').forEach(function (b) { b.addEventListener('click', closeStudies); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && studiesModal.classList.contains('pv-open')) closeStudies(); });
    }

    // -- Ingredient detail popup --------------------------------
    var ingModal = document.getElementById('pv-ing-modal');
    if (ingModal) {
      var ingIcon = document.getElementById('pv-ing-modal-icon');
      var ingTitle = document.getElementById('pv-ing-modal-title');
      var ingBody = document.getElementById('pv-ing-modal-body');
      var ingCloseBtn = ingModal.querySelector('.pv-modal-close');
      var certWrap = document.getElementById('pv-ing-modal-cert');
      var certImgEl = document.getElementById('pv-ing-modal-cert-img');

      function openIng(card) {
        var nameEl = card.querySelector('.pv-ing-name');
        var iconEl = card.querySelector('.pv-ing-icon');
        var detailEl = card.querySelector('.pv-ing-detail');
        // append U+FE0E so emoji-style glyphs (e.g. the lightning bolt) render as a gold text symbol, not a coloured emoji
        ingIcon.innerHTML = iconEl ? iconEl.innerHTML : "";
        ingTitle.textContent = nameEl ? nameEl.textContent : '';
        ingBody.textContent = detailEl ? detailEl.textContent : '';
        if (certWrap) certWrap.hidden = true;
        ingModal.classList.add('pv-open');
        document.body.style.overflow = 'hidden';
        if (ingCloseBtn) ingCloseBtn.focus();
      }
      function closeIng() {
        ingModal.classList.remove('pv-open');
        document.body.style.overflow = '';
      }
      document.querySelectorAll('.pv-ing-card').forEach(function (card) {
        card.addEventListener('click', function () { openIng(card); });
        card.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openIng(card); } });
      });

      // -- Certification detail popup (reuses the ingredient modal) --
      function openCert(card) {
        var nameEl = card.querySelector('.pv-cert-name');
        var descEl = card.querySelector('.pv-cert-desc');
        var detailEl = card.querySelector('.pv-cert-detail');
        ingIcon.textContent = '\u2713';
        ingTitle.textContent = (nameEl ? nameEl.textContent : '') + (descEl ? ': ' + descEl.textContent : '');
        ingBody.textContent = detailEl ? detailEl.textContent : '';
        // Optional redacted certificate image \u2014 shows only if data-pv-cert-img is set and loads.
        if (certWrap && certImgEl) {
          certWrap.hidden = true;
          var imgSrc = card.getAttribute('data-pv-cert-img');
          if (imgSrc) {
            certImgEl.onload = function () { certWrap.hidden = false; };
            certImgEl.onerror = function () { certWrap.hidden = true; };
            certImgEl.alt = (nameEl ? nameEl.textContent : '') + ' certificate (manufacturer details redacted)';
            certImgEl.src = imgSrc;
          }
        }
        ingModal.classList.add('pv-open');
        document.body.style.overflow = 'hidden';
        if (ingCloseBtn) ingCloseBtn.focus();
      }
      document.querySelectorAll('.pv-cert-badge').forEach(function (card) {
        card.addEventListener('click', function () { openCert(card); });
        card.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openCert(card); } });
      });
      ingModal.querySelectorAll('[data-pv-modal-close]').forEach(function (el) {
        el.addEventListener('click', closeIng);
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeIng(); });
    }

  });
}());

/* pvParseBuyHref (2026-09-15): the Buy Now bar's href comes in TWO shapes and both must parse, or the
   express wallet form stops syncing and could pay for the wrong plan.
     a) `/cart/<variant>:<qty>` and `/cart/<variant>:<qty>?selling_plan=<id>`  - the old permalink form.
        Still used by the ONE-OFF cards, where it works correctly. NOTE the plan variant of this shape is
        BROKEN AT SHOPIFY'S END (the parameter is silently dropped, giving a one-off at a higher price),
        which is why pv-pricing.liquid now rewrites it. Kept parseable so an un-rewritten page, a cached
        template or an ad LP that has not re-rendered still behaves.
     b) `/cart/add?id=<variant>&quantity=<qty>&selling_plan=<id>&return_to=/checkout` - the new form, which
        genuinely carries the plan and works with NO JavaScript at all.
   Returns {id, qty, plan} with plan null for a one-off, or null if the href is neither shape. */
window.pvParseBuyHref = function(href){
  if(!href) return null;
  var m = href.match(/\/cart\/(\d+):(\d+)(?:\?.*?selling_plan=(\d+))?/);
  if (m) return { id:m[1], qty:m[2], plan:m[3]||null };
  m = href.match(/\/cart\/add\?(.+)$/);
  if (m) {
    var id=null, qty=null, plan=null;
    m[1].split('&').forEach(function(pair){
      var kv = pair.split('='); var k = kv[0], v = decodeURIComponent(kv[1]||'');
      if (k==='id') id=v; else if (k==='quantity') qty=v; else if (k==='selling_plan') plan=v;
    });
    if (id && qty) return { id:id, qty:qty, plan:plan||null };
  }
  return null;
};

/* === PV fixes 2026-06-05: ingredient-card expand + subscribe Loop selling-plan === */
(function(){
  function init(){
    /* Ingredient cards pop out via the modal (openIng in the main script); inline expand removed. */
    function bindBuy(bar){
      if(!bar||bar._pvSub) return; bar._pvSub=1;
      bar.addEventListener('click', function(e){
        var href=bar.getAttribute('href')||'';
        var d=window.pvParseBuyHref(href);
        if(!d||!d.plan) return;
        e.preventDefault();
        // Single-product funnel: clear the cart first so a previously chosen offer can't linger alongside the new one
        window.pvClearBC()
          .then(function(){ return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:parseInt(d.id,10),quantity:parseInt(d.qty,10),selling_plan:parseInt(d.plan,10)}]})}); })
          .then(function(){ window.location.href='/checkout'; })
          .catch(function(){ window.location.href=href; });   /* safe since 2026-09-15: href is now /cart/add, which carries the plan */
      });
    }
    bindBuy(document.getElementById('pv-buynow'));
    document.querySelectorAll('.pv-buynow-bar').forEach(bindBuy);
  }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();

/* Gold title shine: hero H1 ~2s after load; section titles sweep on scroll-in */
;(function(){
  function shine(el, slow){ if(!el||el.dataset.pvShone) return; el.dataset.pvShone='1'; el.classList.add('pv-shine-go'); if(slow) el.classList.add('pv-shine-slow'); el.addEventListener('animationend', function(){ el.classList.remove('pv-shine-go'); el.classList.remove('pv-shine-slow'); }, {once:true}); }
  var h1=document.querySelector('.pv-hero .pv-h1');
  window.addEventListener('load', function(){ setTimeout(function(){ shine(h1, true); var hp=document.querySelector('.pv-hero .pv-pill-list'); if(hp){ hp.classList.add('pv-pills-go'); } }, 3000); });
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ shine(e.target); io.unobserve(e.target); } }); }, { threshold:0.6 });
    document.querySelectorAll('.pv-section-h.pv-shine-on').forEach(function(h){ io.observe(h); });
    /* Owner 2026-07-30: "make this shine once the customer is fully on this card, slower shine."
       The per-day line is the price reframed, so it gets one slow sweep the first time the shopper
       is properly settled on the card: threshold 1 PLUS a -18% root inset, so it must be well
       inside the viewport rather than clipping the edge. One-shot per element (dataset.pvShone).
       Bound to the CARD, not the line: the line lives inside the card's collapsible details, so
       observing it directly can never fire while a card is closed. Watching the card also matches
       what was asked, "fully on this card". */
    var ioPd = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if (!e.isIntersecting) return;
        var line = e.target.querySelector('.pv-receipt-perday');
        if (line) setTimeout(function(){ shine(line, false); line.classList.add('pv-shine-vslow'); }, 320);
        ioPd.unobserve(e.target);
      });
    }, { threshold: 0.6 });
    document.querySelectorAll('.pv-pricing-stack .pv-option').forEach(function(el){ ioPd.observe(el); });
  }
})();

/* Hero benefit pills: one-time staggered pulse when they scroll into view */
;(function(){
  if(!('IntersectionObserver' in window)) return;
  var io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('pv-pills-go'); io.unobserve(e.target); } }); }, { threshold: 0.5 });
  document.querySelectorAll('.pv-pill-list').forEach(function(el){ if(el.closest('.pv-hero')){ return; } io.observe(el); });
})();

/* Scroll effects: ingredient-card glow (repeatable), cert sequential glow, science-tab slow auto-scroll */
;(function(){
  if('IntersectionObserver' in window){
    var ingIO=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ var c=e.target; if(!c.classList.contains('pv-glow')){ c.classList.add('pv-glow'); c.addEventListener('animationend', function h(){ c.classList.remove('pv-glow'); c.removeEventListener('animationend',h); }); } } }); }, { threshold: 0.75 });
    document.querySelectorAll('.pv-ing-card').forEach(function(el){ ingIO.observe(el); });
    var certIO=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('pv-certs-go'); certIO.unobserve(e.target); } }); }, { threshold: 0.4 });
    document.querySelectorAll('.pv-certs-grid').forEach(function(el){ certIO.observe(el); });
  }
  var rail=document.querySelector('.pv-science-tabs');
  if(rail){
    var raf=null, pos=0;
    function step(){ var max=rail.scrollWidth - rail.clientWidth; if(pos >= max - 1){ raf=null; return; } pos += 0.5; rail.scrollLeft = pos; raf=requestAnimationFrame(step); }
    function stopAuto(){ if(raf){ cancelAnimationFrame(raf); raf=null; } }
    ['pointerdown','wheel','touchstart','keydown'].forEach(function(ev){ rail.addEventListener(ev, stopAuto, { passive: true }); });
    if('IntersectionObserver' in window){
      var sIO=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ sIO.unobserve(e.target); setTimeout(function(){ if(!raf){ pos=rail.scrollLeft; raf=requestAnimationFrame(step); } }, 600); } }); }, { threshold: 0.5 });
      sIO.observe(rail);
    }
  }
})();

/* Express wallet buttons (Apple Pay / Shop Pay): mirror the selected plan from the Buy Now bar into the dynamic-checkout product form, so one tap pays for the chosen plan */
;(function(){
  function init(){
    var bar=document.getElementById('pv-buynow');
    var form=document.getElementById('pv-express-form');
    if(!bar||!form) return;
    var qty=form.querySelector('[data-pv-express-qty]');
    var plan=form.querySelector('[data-pv-express-plan]');
    function sync(){
      var href=bar.getAttribute('href')||'';
      var d=window.pvParseBuyHref(href);
      if(!d) return;
      if(qty) qty.value=d.qty;
      if(plan){ if(d.plan){ plan.value=d.plan; plan.disabled=false; } else { plan.value=''; plan.disabled=true; } }
      /* PLAN = BUY NOW ONLY (T-0461W, 2026-10-02). Real visitors 24 Sep to 2 Oct: the instant wallet buttons
         finished 8 of 10 single-bottle buyers but only 1 of 4 plan buyers; the other 3 closed the wallet sheet
         and left no email to win them back. With the plan selected, the wallets hide, so plan buyers go through
         Buy Now to checkout, which shows the plan's ticks, takes the email first, and still offers Shop Pay,
         Apple Pay and Google Pay at the top. One-off cards keep the instant buttons. */
      var wrap=form.closest('[data-pv-express]');
      if(wrap) wrap.classList.toggle('pv-express--plan-off', !!d.plan);
    }
    sync();
    if('MutationObserver' in window){ new MutationObserver(sync).observe(bar,{attributes:true,attributeFilter:['href']}); }
  }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();

/* Deep link from the subscription policy (owner 2026-07-22): arriving at
   /pages/methylated-b-complex-ultra#subscribe (or ?plan=subscribe) OPENS the 3-month subscription card
   and scrolls the checkout area (Buy Now + Apple Pay / Shop Pay express wallets) into view, so a reader
   who tapped "Back to the product" from the cancellation policy lands ready to subscribe, not at the top
   of the funnel on the default 1-bottle card. Self-contained; runs after the pricing script has wired the
   cards (its DOMContentLoaded handler is registered earlier in the file, so it fires first). */
;(function(){
  function wants(){ return location.hash === '#subscribe' || new URLSearchParams(location.search).get('plan') === 'subscribe'; }
  /* has the selection actually landed on the 3-month plan? (the Buy Now subline reflects the live selection) */
  function planIsSub(){ var el = document.querySelector('.pv-buynow-plan'); return !!(el && /3-?month/i.test(el.textContent)); }
  function run(){
    if (!wants()) return;
    var card = document.querySelector('[data-pv-option="subscribe"]');
    var section = card && card.closest('.pv-pricing-section');
    if (!card || !section) return;
    var tries = 0;
    (function ensureSelected(){
      tries++;
      if (!card.classList.contains('pv-selected')) card.click();  /* runs the card's own select() */
      /* verify it took (guards the race where cards aren't wired yet on first paint); retry up to ~1.8s */
      if (!planIsSub() && tries < 12) { setTimeout(ensureSelected, 150); return; }
      /* selected -> bring the checkout area (Buy Now + Apple Pay / Shop Pay) into view. Delayed past
         select()'s own ~380ms mobile stack-framing scroll so THIS final position wins, and re-asserted
         once more in case of late reflow (the promise block makes the open card tall). */
      var settle = function(){
        // Land like the subscribe card-click framing: anchor the "Subscribe & save more" heading near the
        // top so the card header + Buy Now + Apple Pay / Shop Pay are all in view (owner 2026-07-22).
        // Centering the express block scrolled TOO FAR (the card header ended up off the top of the screen).
        var head = section.querySelector('.pv-plan-grouphead--sub') || card;
        var y = Math.max(0, head.getBoundingClientRect().top + window.scrollY - 16);
        try { window.scrollTo({ top: y, behavior: 'smooth' }); } catch(e){ try { window.scrollTo(0, y); } catch(e2){} }
      };
      setTimeout(settle, 650);
      setTimeout(settle, 1100);
    })();
  }
  /* run on load (cards are definitely wired by then); the retry loop covers any remaining timing */
  if (document.readyState === 'complete') run(); else window.addEventListener('load', run);
})();

/* ONE-BOTTLE UPSELL (HQ-0 "aov-options", owner 2026-10-08). Tapping Buy Now with 1 bottle selected opens, ONCE per
   visit, a small centred card with ONE offer: "Get 3 for £15 each" on the 3-month plan, or carry on with 1 bottle.
   Price per bottle is read from the plan card's own "Total to pay" AFTER any code has re-priced it, so a visitor with
   a 10% code sees £13.50 (with "first delivery, then £15" underneath, because codes apply to the first delivery
   only) and everyone else sees £15. The instant wallet button is not intercepted (a wallet must open from the tap
   itself). Choices go to Clarity as upsell_<shown|plan|single|dismiss> and to the pixel bus as pv_upsell. */
;(function(){
  var KEY='pv_ups_seen';
  function seen(){ try{ return sessionStorage.getItem(KEY)==='1'; }catch(e){ return false; } }
  function mark(){ try{ sessionStorage.setItem(KEY,'1'); }catch(e){} }
  function num(t){ var m=String(t||'').replace(/,/g,'').match(/(\d+(?:\.\d+)?)/); return m? parseFloat(m[1]) : NaN; }
  function money(n){ n=Math.round(n*100)/100; return '£'+(n%1? n.toFixed(2): String(n)); }
  function ev(name){ try{ if(window.clarity) window.clarity('event','upsell_'+name); }catch(e){}
    try{ if(window.Shopify&&Shopify.analytics&&Shopify.analytics.publish) Shopify.analytics.publish('pv_upsell',{choice:name}); }catch(e){} }
  function init(){
    var bar=document.getElementById('pv-buynow'); var sec=document.getElementById('pricing');
    if(!bar||!sec) return;
    if(sec.hasAttribute('data-pv-google')) return;   /* Google Shopping page (owner 2026-10-12): no 1-bottle pop-up, Buy Now goes straight to checkout */
    if(/^\/pages\/methylated-b-complex-ultra\/?$/.test(location.pathname)) return;   /* main sales page (owner 2026-10-13: "get rid of that"): no 1-bottle pop-up either */
    var oPlan=sec.querySelector('[data-pv-option="subscribe"]'), oOne=sec.querySelector('[data-pv-option="single"]');
    if(!oPlan||!oOne) return;
    var dlg=null;
    function prices(){
      var list=parseFloat(oPlan.getAttribute('data-pv-total'));
      var tot=oPlan.querySelector('.pv-receipt-total-row span:last-child'); var now=num(tot&&tot.textContent);
      if(!(now>0)) now=list;
      var row=oPlan.querySelector('.pv-receipt-promo-row'); var coded=row&&!row.hidden&&now<list-0.005;
      var lab=row&&row.querySelector('[data-pv-promo-label]');
      var t1=oOne.querySelector('.pv-receipt-total-row span:last-child, [data-pv-total-banner-price]'); var one=num(t1&&t1.textContent); if(!(one>0)) one=parseFloat(oOne.getAttribute('data-pv-total'));
      var oneList=parseFloat(oOne.getAttribute('data-pv-total')); var pct=oneList>0? Math.round((1-(now/3)/oneList)*100) : 0;
      /* Owner 2026-10-08 ("too much to click on... really clear very quickly"): no separate unlock step. The offer is
         always the plan with 10% off the first delivery: their own code if they already have one, otherwise PLANEXTRA10,
         which "Yes" puts on the session just before checkout. */
      if(!coded) now=Math.round(list*0.9*100)/100;
      pct=oneList>0? Math.round((1-(now/3)/oneList)*100) : 0;
      return { each: now/3, total: now, list: list, listEach: list/3, one: one, pct: pct, coded: coded, code: lab? lab.textContent.trim() : '' };
    }
    var CSS=".pv-ups{border:0;padding:0;margin:auto;width:calc(100% - 40px);max-width:360px;background:transparent;overflow:visible;}\n.pv-ups::backdrop{background:rgba(16,30,22,.6);}\n.pv-ups-in{position:relative;background:#f9f5ef;border-radius:20px;padding:24px 20px 18px;text-align:center;font-family:Figtree,-apple-system,sans-serif;color:#1a3a2a;box-shadow:0 18px 50px rgba(0,0,0,.3);}\n.pv-ups-x{position:absolute;top:10px;right:10px;width:44px;height:44px;border:0;border-radius:50%;background:#ebe4d6;color:#1a3a2a;font:400 30px/44px Figtree,-apple-system,sans-serif;text-align:center;padding:0;cursor:pointer;}\n.pv-ups-x:active{background:#ddd4c2;}\n.pv-ups-pic{position:relative;width:200px;margin:0 auto 10px;}.pv-ups-img{display:block;width:150px;height:auto;margin:0 auto;}.pv-ups-stk{position:absolute;top:-6px;right:-14px;width:76px;height:76px;border-radius:50%;background:#c8202f;color:#fff;display:flex;flex-direction:column;align-items:center;justify-content:center;transform:rotate(-12deg);box-shadow:0 4px 12px rgba(120,10,20,.35);font-family:Figtree,-apple-system,sans-serif;line-height:1;}.pv-ups-stk b{font-size:25px;font-weight:800;letter-spacing:-.02em;}.pv-ups-stk span{font-size:12.5px;font-weight:800;letter-spacing:.08em;margin-top:2px;}\n.pv-ups-h{font-size:27px;font-weight:800;line-height:1.12;margin:0 0 6px;text-wrap:balance;letter-spacing:-.01em;}\n.pv-ups-sub{font-size:14.5px;color:#4d5e55;margin:0 0 16px;}\n.pv-ups-yes{display:block;width:100%;border:0;border-radius:999px;padding:15px 16px;background:linear-gradient(180deg,#e7cf9b,#cba866);color:#1a3a2a;font:800 17px/1.2 Figtree,-apple-system,sans-serif;cursor:pointer;box-shadow:0 6px 18px rgba(203,168,102,.35);}\n.pv-ups-no{display:block;width:100%;margin-top:10px;border:1.5px solid #1a3a2a;border-radius:999px;background:transparent;color:#1a3a2a;font:700 16px/1.2 Figtree,-apple-system,sans-serif;padding:13px 16px;cursor:pointer;}\n.pv-ups-small{font-size:11.5px;color:#7c8a82;margin:8px 0 0;}\n.pv-ups button:disabled{opacity:.75;cursor:default;}.pv-ups-unlock{display:flex;align-items:center;gap:11px;width:100%;margin:0 0 12px;padding:11px 11px 11px 13px;border:1.5px solid #cba866;border-radius:14px;background:linear-gradient(180deg,#fff7e3,#f6e8c4);color:#1a3a2a;text-align:left;cursor:pointer;font-family:Figtree,-apple-system,sans-serif;box-shadow:0 4px 12px rgba(150,115,40,.18),inset 0 1px 0 rgba(255,255,255,.7);transition:transform .08s ease;}.pv-ups-unlock:active{transform:scale(.98);}.pv-ul-ic{width:26px;height:26px;flex:none;color:#b08a3e;}.pv-ul-t{flex:1;min-width:0;display:flex;flex-direction:column;line-height:1.2;}.pv-ul-t b{font-size:16px;font-weight:800;}.pv-ul-t small{font-size:12px;color:#5b6b62;margin-top:2px;}.pv-ul-go{flex:none;background:#1a3a2a;color:#f9f5ef;font-weight:800;font-size:14px;border-radius:999px;padding:9px 16px;box-shadow:0 2px 6px rgba(26,58,42,.3);}.pv-ups-unlock.is-on{border-color:#2e7d4f;background:#eaf5ee;box-shadow:none;cursor:default;opacity:1;}.pv-ul-ok{width:26px;height:26px;flex:none;border-radius:50%;background:#2e7d4f;color:#fff;display:grid;place-items:center;font-weight:800;font-size:15px;}.pv-ups-unlock.is-on .pv-ul-t b{color:#1f6b42;}.pv-ups-yes.is-going,.pv-ups-yes.is-going:disabled{position:relative;overflow:hidden;background:#3f7a5a;color:#f9f5ef;box-shadow:none;opacity:1;transition:background-color .15s ease;}.pv-ups-yes.is-going::after{content:\"\";position:absolute;left:0;bottom:0;height:3px;width:0;background:#cba866;animation:pv-ups-bar 2.4s cubic-bezier(.2,.7,.3,1) forwards;}@keyframes pv-ups-bar{to{width:92%;}}@media (prefers-reduced-motion: reduce){.pv-ups-yes.is-going::after{animation:none;width:60%;}}";
    var LOCK='<svg class="pv-ul-ic" viewBox="0 0 24 24" aria-hidden="true"><rect x="4.5" y="10.5" width="15" height="10" rx="2.2" fill="currentColor"/><path d="M8 10.5V7.8a4 4 0 0 1 7.6-1.7" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>';
    var UL_IDLE=LOCK+'<span class="pv-ul-t"><b>Extra 10% off</b><small>Tap to unlock on the plan</small></span><span class="pv-ul-go">Unlock</span>';
    function build(){
      if(!document.getElementById('pv-ups-css')){ var st=document.createElement('style'); st.id='pv-ups-css'; st.textContent=CSS; document.head.appendChild(st); }
      var p=prices(); var img=oPlan.querySelector('img'); var pic=sec.getAttribute('data-pv-ups-img') || (img&&(img.currentSrc||img.src));
      dlg=document.createElement('dialog'); dlg.className='pv-ups'; dlg.setAttribute('aria-labelledby','pv-ups-h');
      dlg.innerHTML='<div class="pv-ups-in">'+
        '<button type="button" class="pv-ups-x" data-ups="close" aria-label="Close">&#215;</button>'+
        '<div class="pv-ups-pic">'+(pic? '<img class="pv-ups-img" alt="3 bottles of Methylated B Complex Ultra" src="'+pic+'">' : '')+(p.pct>0? '<span class="pv-ups-stk" aria-hidden="true"><b>'+p.pct+'%</b><span>OFF</span></span>' : '')+'</div>'+
        '<p class="pv-ups-h" id="pv-ups-h">Get 3 for '+money(p.each)+' each</p>'+
        '<p class="pv-ups-sub">3-month plan. '+money(p.total)+' today, then '+money(p.list)+' every&nbsp;3&nbsp;months. Cancel any&nbsp;time.</p>'+
        '<button type="button" class="pv-ups-yes" data-ups="plan">Yes, get 3 for '+money(p.total)+'</button>'+
        '<button type="button" class="pv-ups-no" data-ups="single">Just 1 bottle, '+money(p.one)+'</button>'+
      '</div>';
      document.body.appendChild(dlg);
      dlg.addEventListener('click', function(e){
        if(e.target===dlg){ ev('dismiss'); leave(); dlg.close(); return; }
        var b=e.target.closest('[data-ups]'); if(!b) return;
        var k=b.getAttribute('data-ups');
        if(k==='close'){ ev('dismiss'); leave(); dlg.close(); return; }
        if(k==='unlock'){ ev('unlock'); unlock(b); return; }
        ev(k); go(k, b);
      });
      dlg.addEventListener('cancel', function(){ ev('dismiss'); leave(); });
    }
    var mode='buy';
    /* EXTRA 10% (owner 2026-10-08: "add the 10% button with a plan-only code"). PLANEXTRA10 is a Shopify code that
       works ONLY on the 3-month plan, first delivery only (verified by Storefront cartCreate: plan 40.50, 1 bottle 25,
       3 bottles 51). The button puts it on the visitor's session through Shopify's own /discount/ route (the same
       cookie every code uses, so it reaches checkout and the wallets) and re-prices this card. If they then leave or
       choose 1 bottle, the code is taken off again, so a 1-bottle checkout never shows a code that does not apply. It
       is NOT in CODES on purpose: the page's cards would otherwise take 10% off the one-off cards too. */
    var CODE='PLANEXTRA10', unlocked=false;
    function leave(){ if(unlocked){ try{ document.cookie='discount_code=; Max-Age=0; path=/'; }catch(e){} unlocked=false; } }
    function unlock(b){
      b.disabled=true; var go_=b.querySelector('.pv-ul-go'); if(go_) go_.textContent='...';
      fetch('/discount/'+CODE+'?redirect=%2Fcart.js',{credentials:'same-origin'}).then(function(){
        unlocked=true;
        var p=prices(), each=Math.round(p.listEach*0.9*100)/100, oneList=parseFloat(oOne.getAttribute('data-pv-total'));
        var h=dlg.querySelector('#pv-ups-h'); if(h) h.textContent='Get 3 for '+money(each)+' each';
        var stk=dlg.querySelector('.pv-ups-stk b'); if(stk&&oneList>0) stk.textContent=Math.round((1-each/oneList)*100)+'%';
        var y=dlg.querySelector('.pv-ups-yes'); if(y) y.textContent='Yes, get 3 for '+money(each*3);
        var sm=dlg.querySelector('.pv-ups-small'); if(sm){ sm.textContent=money(each)+' each on your first delivery, then '+money(p.listEach)+' each.'; sm.hidden=false; }
        b.innerHTML='<span class="pv-ul-ok" aria-hidden="true">&#10003;</span><span class="pv-ul-t"><b>Extra 10% off unlocked</b><small>Now '+money(each)+' a bottle on your first delivery</small></span>'; b.classList.add('is-on');
      }).catch(function(){ b.disabled=false; b.innerHTML=UL_IDLE; });
    }
    function go(k, b){
      if(k==='single') leave();
      if(k==='single'&&mode==='card'){ dlg.close(); return; }
      /* Owner 2026-10-08: "Yes" gets the same tap feedback as Buy Now on the plan card (snippets/pv-buy-feedback.liquid):
         lighter green, "Opening checkout", a gold bar running along the bottom. */
      if(b.classList.contains('pv-ups-yes')) b.classList.add('is-going');
      b.textContent='Opening checkout'; dlg.querySelectorAll('button').forEach(function(x){ x.disabled=true; });
      if(k==='plan'){
        var d=window.pvParseBuyHref(oPlan.getAttribute('data-pv-href')||'');
        if(!d){ window.location.href=oPlan.getAttribute('data-pv-href'); return; }
        var pp=prices();
        (pp.coded? Promise.resolve() : fetch('/discount/'+CODE+'?redirect=%2Fcart.js',{credentials:'same-origin'}).catch(function(){}))
          .then(function(){ return window.pvClearBC(); })
          .then(function(){ return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:parseInt(d.id,10),quantity:parseInt(d.qty,10),selling_plan:parseInt(d.plan,10)}]})}); })
          .then(function(r){ if(!r.ok) throw 0; window.location.href='/checkout'; })
          .catch(function(){ window.location.href='/cart/add?id='+d.id+'&quantity='+d.qty+'&selling_plan='+d.plan+'&return_to=/checkout'; });
      } else { window.location.href=oOne.getAttribute('data-pv-href') || bar.getAttribute('href'); }
    }
    function open(m){
      mode=m; mark(); if(dlg){ dlg.remove(); } build();
      try{ dlg.showModal(); }catch(err){ return false; }
      ev('shown_'+m); return true;
    }
    /* Shown when the 1-bottle card is TAPPED (owner 2026-10-08: the instant Shop Pay / Apple Pay button opens its own
       sheet from the tap, so nothing can sit in front of it; showing the offer when 1 bottle is chosen catches both
       buttons). "Just 1 bottle" then just closes it, with 1 bottle still selected. */
    /* Owner 2026-10-08: wait about 3 seconds after the tap, so they can read the card first. Cancelled if they pick
       another card, tap the instant wallet button (they are paying), or tap Buy Now (which opens it at once). */
    var tmr=null;
    oOne.addEventListener('click', function(e){
      if(seen()||!window.HTMLDialogElement) return;
      if(e.target&&e.target.closest&&e.target.closest('a, input, select, [data-pv-qty], .shopify-payment-button')) return;
      clearTimeout(tmr);
      tmr=setTimeout(function(){ tmr=null; if(!seen()&&oOne.classList.contains('pv-selected')&&!document.querySelector('dialog[open]')) open('card'); }, 3000);
    });
    sec.addEventListener('click', function(e){
      if(tmr&&e.target&&e.target.closest&&e.target.closest('.shopify-payment-button, [data-pv-option]:not([data-pv-option="single"])')){ clearTimeout(tmr); tmr=null; }
    }, true);
    document.addEventListener('click', function(e){
      var el=e.target&&e.target.closest? e.target.closest('#pv-buynow'):null; if(!el) return;
      var d=window.pvParseBuyHref(el.getAttribute('href')||'');
      if(!d||d.plan||String(d.qty)!=='1'||seen()) return;
      if(!window.HTMLDialogElement) return;
      e.preventDefault(); e.stopPropagation();
      if(!open('buy')) window.location.href=el.getAttribute('href');
    }, true);
  }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();

/* OFFER COUNTDOWN IN THE TOP BAR (owner 2026-10-15: "move this to the top bar that stays on the page... when the toolbar
   disappears over the sales cards, it just changes to the limited time offer with the countdown"). The countdown bar is
   moved out of the plans into a slim fixed strip that shows only while the plans are on screen. It sits under the site
   header, so when the header slides back in it covers the strip. Same element, so the countdown and its fail-safe still
   run on it; nothing shows when there is no offer. */
;(function(){
  function init(){
    var sec = document.getElementById('pricing'); if (!sec) return;
    var bar = sec.querySelector('.pv-offer-bar[data-pv-offer-end]'); if (!bar) return;
    var wrap = document.createElement('div'); wrap.className = 'pv-offer-sticky'; wrap.setAttribute('aria-live', 'off');
    document.body.appendChild(wrap); wrap.appendChild(bar);
    function upd(){
      var r = sec.getBoundingClientRect();
      wrap.classList.toggle('is-on', !bar.hidden && r.top < window.innerHeight * 0.55 && r.bottom > 140);
    }
    window.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
    setInterval(upd, 1000);
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();

/* Reviews before the evidence (owner 2026-10-15, on the Customer Reviews block: "move this up one block"). The dark
   "Clinical evidence" block is rendered at the end of the pricing section, so it is moved to sit after the video wall. */
;(function(){
  function init(){
    var ce = document.getElementById('clinical-evidence');
    var vw = document.querySelector('.shopify-section[id$="__videowall"]');
    if (!ce || !vw || !ce.closest('.shopify-section[id$="__pricing"]')) return;
    vw.parentNode.insertBefore(ce, vw.nextSibling);
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();

